import { Component } from '@angular/core';

@Component({
  template: `
    <svg xmlns="http://www.w3.org/2000/svg">
      <symbol id="component-bg">
        <path
          d="M4 80.5c-1.4 0-2.5-1.1-2.5-2.5V4c0-1.4 1.1-2.5 2.5-2.5h128c1.4 0 2.5 1.1 2.5 2.5v74c0 1.4-1.1 2.5-2.5 2.5H4z"
          fill="#fff"
        />
        <path
          d="M132 3c.6 0 1 .4 1 1v74c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h128m0-3H4C1.8 0 0 1.8 0 4v74c0 2.2 1.8 4 4 4h128c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4z"
          fill="#a5a5a5"
        />
      </symbol>
      <symbol id="component-duplicate">
        <g fill="#3f3f3f">
          <path d="M8 8.5h11v-5c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h5v-9c0-.6.4-1 1-1z" />
          <path d="M26 26.5H11c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2h15c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2z" />
        </g>
      </symbol>
      <symbol id="component-remove">
        <path
          fill="#ff1d25"
          d="M25.8 6.7l-3.5-3.5-7.8 7.8-7.8-7.8-3.5 3.5 7.8 7.8-7.8 7.8 3.5 3.5 7.8-7.8 7.8 7.8 3.5-3.5-7.8-7.8z"
        />
      </symbol>
      <symbol id="component-test">
        <path d="M4 28.5c-1.4 0-2.5-1.1-2.5-2.5V1.5h133V26c0 1.4-1.1 2.5-2.5 2.5H4z" fill="#0ab3e5" />
        <path
          d="M133 3v23c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V3h130m3-3H0v26c0 2.2 1.8 4 4 4h128c2.2 0 4-1.8 4-4V0z"
          fill="#0ab3e5"
        />
        <path d="M74 15h-5v-5h-3v5h-5v3h5v5h3v-5h5z" />
      </symbol>
      <symbol id="icon-aggregate" viewBox="0 0 17 18">
        <rect x="6.4164" y="1" width="4.16677" height="4.16677" rx="1" />
        <rect x="1" y="13" width="4.16677" height="4.16677" rx="1" />
        <rect x="11.832" y="13" width="4.16677" height="4.16677" rx="1" />
        <rect x="6.4164" y="13" width="4.16677" height="4.16677" rx="1" />
        <path
          d="M8.50019 5.79199L8.50019 7.62544C8.50019 9.14423 9.73141 10.3754 11.2502 10.3754L11.8754 10.3754C13.0489 10.3754 14.0002 11.3267 14.0002 12.5002V12.5002"
        />
        <path
          d="M8.29145 5.79199L8.29145 7.8129C8.29145 9.22816 7.14416 10.3754 5.72891 10.3754V10.3754C4.31366 10.3754 3.16637 11.5227 3.16637 12.938L3.16637 13.0002"
        />
        <line x1="8.41521" y1="5.91699" x2="8.41521" y2="11.9172" />
      </symbol>
      <symbol id="icon-amazon-redshift" viewBox="0 0 16 16">
        <path
          d="M4.49994 2.6121L6.24991 1H9.9443L11.4998 2.6121V12.6877L9.9443 14.2998H6.24991L4.49994 12.6877V2.6121Z"
        />
        <path
          d="M11.7691 4.19806L11.7691 10.7248L13.3007 11.769L14.9998 11.769L14.9998 3.15379L13.3007 3.15379L11.7691 4.19806Z"
        />
        <path d="M4.23072 10.7248L4.23072 4.19808L2.69912 3.15381H1L1 11.7691H2.69912L4.23072 10.7248Z" />
      </symbol>
      <symbol id="icon-app-delete-list">
        <path
          fill="#3F3F3F"
          d="M12.5 2.1L10.4 0 6.2 4.2 2.1 0 0 2.1l4.2 4.1L0 10.4l2.1 2.1 4.1-4.2 4.2 4.2 2.1-2.1-4.2-4.2z"
        />
      </symbol>
      <symbol id="icon-app-duplicate-list">
        <path fill="#3F3F3F" d="M5 4h9V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v7c0 1.1.9 2 2 2h2V5c0-.6.4-1 1-1z" />
        <path fill="#3F3F3F" d="M19 7c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7z" />
      </symbol>
      <symbol id="icon-app-package-list">
        <path fill="#999" d="M23 20c0 1.7-1.3 3-3 3H3c-1.7 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3h17c1.7 0 3 1.3 3 3v17z" />
        <path fill="#3F3F3F" d="M12 8h-1c-.6 0-1-.4-1-1V0h3v7c0 .6-.4 1-1 1z" />
        <circle fill="#3F3F3F" cx="19" cy="4" r=".8" />
      </symbol>
      <symbol id="icon-app-runjob-list">
        <path
          fill="#39E98D"
          stroke="#3F3F3F"
          stroke-width="2"
          stroke-miterlimit="10"
          d="M3.8 1.3l10.6 6.3c1.1.6 1 2.2-.1 2.8L3.9 16.7c-1.5.9-2.9-.2-2.9-1.9V3.2C1 1.5 2.3.4 3.8 1.3z"
        />
      </symbol>
      <symbol id="icon-app-search">
        <path
          opacity=".5"
          fill="#3F3F3F"
          d="M21 19.6l-5-5c2.8-3.5 2.6-8.7-.7-12C13.6.9 11.3 0 9 0S4.4.9 2.6 2.6c-3.5 3.5-3.5 9.2 0 12.7C4.4 17.1 6.7 18 9 18c2 0 4-.7 5.6-2l5 5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zM4.1 13.9C2.7 12.6 2 10.9 2 9s.7-3.6 2.1-4.9C5.4 2.7 7.1 2 9 2s3.6.7 4.9 2.1c2.7 2.7 2.7 7.2 0 9.9-1.3 1.3-3.1 2-4.9 2-1.9 0-3.6-.7-4.9-2.1z"
        />
      </symbol>
      <symbol id="icon-app-terminal-02">
        <path fill="#FFF" d="M24 7V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v5h24z" />
        <path fill="#E6E6E6" d="M0 8v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V8H0z" />
        <circle fill="#3F3F3F" cx="3.5" cy="3.5" r="1.5" />
        <circle fill="#3F3F3F" cx="8.5" cy="3.5" r="1.5" />
        <circle fill="#3F3F3F" cx="13.5" cy="3.5" r="1.5" />
      </symbol>
      <symbol id="icon-app-workflow-list">
        <g fill="#999">
          <path d="M7 5h16V3c0-1.7-1.3-3-3-3H3C1.3 0 0 1.3 0 3v17c0 1.7 1.3 3 3 3h1V8c0-1.5 1.5-3 3-3z" />
          <path d="M26 7H9c-1.7 0-3 1.3-3 3v17c0 1.7 1.3 3 3 3h17c1.7 0 3-1.3 3-3V10c0-1.7-1.3-3-3-3z" />
        </g>
        <path fill="#3F3F3F" d="M10 0h3v5h-3zM18 15h-1c-.6 0-1-.4-1-1V7h3v7c0 .6-.4 1-1 1z" />
        <circle fill="#3F3F3F" cx="25" cy="11" r=".8" />
      </symbol>
      <symbol id="icon-assert" viewBox="0 0 16 16">
        <path
          d="M15 7.36V8.004C14.9991 9.5135 14.5103 10.9823 13.6065 12.1913C12.7027 13.4003 11.4323 14.2847 9.98475 14.7127C8.5372 15.1407 6.99008 15.0893 5.57413 14.5662C4.15818 14.0431 2.94926 13.0763 2.12767 11.81C1.30609 10.5436 0.915854 9.04565 1.01517 7.53942C1.11449 6.0332 1.69804 4.59943 2.6788 3.45196C3.65955 2.30448 4.98495 1.50477 6.45733 1.17211C7.92971 0.839443 9.47019 0.991643 10.849 1.60601M15 2.40401L8 9.411L5.9 7.31101"
        />
      </symbol>
      <symbol id="icon-big-query" viewBox="0 0 18 15">
        <path d="M16.5 7.5L12.75 13.9952L5.25 13.9952L1.5 7.5L5.25 1.00481L12.75 1.00481L16.5 7.5Z" />
        <circle cx="8.99973" cy="6.96415" r="2.14286" />
        <path d="M10.0774 9.46631L10.6069 10.7141" />
      </symbol>
      <symbol id="icon-bing-ads" viewBox="0 0 14 20">
        <path
          d="m 7.1014471,10.66925 2.2252515,1.140209 -4.5387267,2.862076 V 2.2826922 L 1.5655507,1.0443824 V 16.704825 l 3.2242569,1.959242 8.0593574,-5.077538 V 9.5969395 L 5.6975289,6.8527429 Z"
        />
      </symbol>
      <symbol id="icon-clone" viewBox="0 0 16 16">
        <path
          d="M3.1 10.1H2.4C2.0287 10.1 1.6726 9.9525 1.41005 9.68995C1.1475 9.4274 1 9.0713 1 8.7V2.4C1 2.0287 1.1475 1.6726 1.41005 1.41005C1.6726 1.1475 2.0287 1 2.4 1H8.7C9.0713 1 9.4274 1.1475 9.68995 1.41005C9.9525 1.6726 10.1 2.0287 10.1 2.4V3.1M7.3 5.9H13.6C14.3732 5.9 15 6.5268 15 7.3V13.6C15 14.3732 14.3732 15 13.6 15H7.3C6.5268 15 5.9 14.3732 5.9 13.6V7.3C5.9 6.5268 6.5268 5.9 7.3 5.9Z"
        />
      </symbol>
      <symbol id="icon-clusters">
        <style>
          .st1 {
            fill: #fff;
          }
        </style>
        <path d="M28.3 30.3H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h24.3c1.1 0 2 .9 2 2v24.3c0 1.1-.9 2-2 2z" fill="#999" />
        <circle class="st1" cx="24.7" cy="15.2" r="1.9" />
        <circle class="st1" cx="24.7" cy="22.8" r="1.9" />
        <circle class="st1" cx="24.7" cy="7.7" r="1.9" />
      </symbol>
      <symbol id="icon-connections">
        <style>
          .st0 {
            fill: #999;
          }
        </style>
        <circle class="st0" cx="16.5" cy="16.5" r="12.9" />
        <circle class="st0" cx="16.5" cy="16.5" r="5.8" />
        <path
          d="M16.5 12.2c2.4 0 4.3 1.9 4.3 4.3s-1.9 4.3-4.3 4.3-4.3-1.9-4.3-4.3 1.9-4.3 4.3-4.3m0-3c-4 0-7.3 3.3-7.3 7.3s3.3 7.3 7.3 7.3 7.3-3.3 7.3-7.3-3.3-7.3-7.3-7.3z"
          fill="#e6e6e6"
        />
      </symbol>
      <symbol id="icon-cross-join" viewBox="0 0 16 17">
        <rect x="1" y="1" width="5" height="5" rx="1" />
        <rect x="1" y="11" width="5" height="5" rx="1" />
        <rect x="10" y="11" width="5" height="5" rx="1" />
        <rect x="10" y="1" width="5" height="5" rx="1" />
        <path d="M5.51411 5.76837L10 11" />
        <path d="M10.5352 5.52498L5.49959 10.9998" />
      </symbol>
      <symbol id="icon-cube" viewBox="0 0 16 18">
        <path
          d="M1.21 4.85618L8 8.78396L14.79 4.85618M8 16.6162V8.77618M15 11.8873V5.66507C14.9997 5.39228 14.9277 5.12437 14.7912 4.8882C14.6547 4.65203 14.4585 4.45591 14.2222 4.31952L8.77778 1.2084C8.5413 1.07188 8.27306 1 8 1C7.72694 1 7.4587 1.07188 7.22222 1.2084L1.77778 4.31952C1.54154 4.45591 1.34532 4.65203 1.2088 4.8882C1.07229 5.12437 1.00028 5.39228 1 5.66507V11.8873C1.00028 12.1601 1.07229 12.428 1.2088 12.6642C1.34532 12.9003 1.54154 13.0965 1.77778 13.2328L7.22222 16.344C7.4587 16.4805 7.72694 16.5524 8 16.5524C8.27306 16.5524 8.5413 16.4805 8.77778 16.344L14.2222 13.2328C14.4585 13.0965 14.6547 12.9003 14.7912 12.6642C14.9277 12.428 14.9997 12.1601 15 11.8873Z"
        />
      </symbol>
      <symbol id="icon-dashboard">
        <path fill="#999" d="M32 19v-1.6l-4-4.7V2h-4v6.1L16.3 0 0 17.4V19h5v13h8V19h6v13h9V19z" />
      </symbol>
      <symbol id="icon-database" viewBox="0 0 16 17">
        <path
          d="M14.5 3.16667C14.5 4.36328 11.5899 5.33333 8 5.33333C4.41015 5.33333 1.5 4.36328 1.5 3.16667M14.5 3.16667C14.5 1.97005 11.5899 1 8 1C4.41015 1 1.5 1.97005 1.5 3.16667M14.5 3.16667V13.2778C14.5 14.4767 11.6111 15.4444 8 15.4444C4.38889 15.4444 1.5 14.4767 1.5 13.2778V3.16667M14.5 8.22222C14.5 9.42111 11.6111 10.3889 8 10.3889C4.38889 10.3889 1.5 9.42111 1.5 8.22222"
        />
      </symbol>
      <symbol id="icon-distinct" viewBox="0 0 15 15">
        <rect x="1" y="9.875" width="4.13" height="4.13" rx="2" />
        <rect x="1" y="2" width="4.13" height="4.13" rx="2" />
        <rect x="8.875" y="9.875" width="4.13" height="4.13" rx="2" />
        <rect x="7.875" y="1" width="6.13" height="6.13" rx="2" />
      </symbol>
      <symbol id="icon-edit">
        <g fill="#0ab3e5"><path d="M14.2 23.8l-6.5-6.5L22 3l6.4 6.4zM3.2 28.3l2-8.4 6.4 6.5z" /></g>
      </symbol>
      <symbol id="icon-execute-sql" viewBox="0 0 17 18">
        <path
          d="m 5.2639981,9.4839163 q 0,0.3398437 -0.1601563,0.6718747 -0.15625,0.332032 -0.4414062,0.5625 -0.3125,0.25 -0.7304688,0.390625 -0.4140625,0.140625 -1,0.140625 -0.6289062,0 -1.1328125,-0.117187 -0.5,-0.117188 -1.01953121,-0.347656 V 9.8159475 h 0.0546875 q 0.44140621,0.3671875 1.01953121,0.5664065 0.578125,0.199219 1.0859375,0.199219 0.71875,0 1.1171875,-0.269532 0.4023438,-0.269531 0.4023438,-0.7187497 0,-0.3867188 -0.1914063,-0.5703125 Q 4.0804043,8.839385 3.6936856,8.7378225 3.4007168,8.6596975 3.0569668,8.6089163 2.7171231,8.558135 2.3343106,8.48001 1.5608731,8.3159475 1.1858731,7.9214163 0.81477934,7.5229788 0.81477934,6.88626 q 0,-0.7304687 0.61718746,-1.1953125 0.6171875,-0.46875 1.5664063,-0.46875 0.6132812,0 1.125,0.1171875 0.5117187,0.1171875 0.90625,0.2890625 V 6.54251 h -0.054687 q -0.3320313,-0.28125 -0.875,-0.4648437 -0.5390625,-0.1875 -1.1054688,-0.1875 -0.6210937,0 -1,0.2578125 -0.375,0.2578125 -0.375,0.6640625 0,0.3632812 0.1875,0.5703125 0.1875,0.2070312 0.6601563,0.3164062 0.25,0.054687 0.7109375,0.1328125 0.4609375,0.078125 0.78125,0.1601563 0.6484375,0.171875 0.9765625,0.5195312 0.328125,0.3476563 0.328125,0.9726563 z"
        />
        <path
          d="m 11.693686,12.569854 q -0.234375,0.05859 -0.464844,0.08203 -0.226563,0.02734 -0.464844,0.02734 -0.679687,0 -1.0937499,-0.375 -0.4101563,-0.371094 -0.4453125,-1.066406 -0.09375,0.01563 -0.1835938,0.01953 -0.085937,0.0078 -0.1679687,0.0078 -0.6132813,0 -1.1171875,-0.203125 -0.5,-0.203125 -0.8515625,-0.589843 -0.3515625,-0.386719 -0.5429688,-0.9492192 -0.1875,-0.5625 -0.1875,-1.2851563 0,-0.7109375 0.1875,-1.2734375 0.1875,-0.5664062 0.546875,-0.96875 0.34375,-0.3828125 0.8515625,-0.5859375 0.5117188,-0.203125 1.1132813,-0.203125 0.625,0 1.1210937,0.2070313 0.5000002,0.203125 0.8476562,0.5820312 0.355469,0.390625 0.542969,0.9570313 0.191406,0.5664062 0.191406,1.2851562 0,1.0664063 -0.4375,1.7968755 -0.433594,0.730468 -1.1679687,1.023437 0.015625,0.445313 0.2109377,0.691406 0.195312,0.246094 0.710937,0.246094 0.160157,0 0.378907,-0.05078 0.222656,-0.04687 0.316406,-0.08594 h 0.105469 z M 10.771811,8.2378225 q 0,-1.1328125 -0.507813,-1.7460937 -0.5078124,-0.6171875 -1.3867187,-0.6171875 -0.8867187,0 -1.3945312,0.6171875 -0.5039063,0.6132812 -0.5039063,1.7460937 0,1.1445313 0.515625,1.7539063 0.515625,0.6054692 1.3828125,0.6054692 0.8671875,0 1.3789067,-0.6054692 0.515625,-0.609375 0.515625,-1.7539063 z"
        />
        <path d="M 16.482748,11.144073 H 12.803061 V 5.3276663 h 0.773437 v 5.1289067 h 2.90625 z" />
      </symbol>
      <symbol id="icon-hubspot" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M 11.802986,5.8632143 V 4.1065967 A 1.3928289,1.3527374 0 0 0 12.606061,2.8873353 V 2.847031 c 0,-0.7470952 -0.623593,-1.352737 -1.392768,-1.352737 h -0.04156 c -0.769237,0 -1.3928292,0.6056418 -1.3928292,1.352737 V 2.887335 A 1.3928289,1.3527374 0 0 0 10.581977,4.1065967 V 5.8632143 A 3.9440805,3.8305531 0 0 0 8.7066053,6.6651413 L 3.7461923,2.9126969 c 0.03537,-0.12401 0.053821,-0.2515323 0.055904,-0.3795306 A 1.5692466,1.5240769 0 1 0 2.2308278,4.0542668 1.5522668,1.507586 0 0 0 3.0036208,3.8500646 l 4.8845857,3.6915401 c -0.8980264,1.3175528 -0.873996,3.0346993 0.060502,4.3281403 l -1.4856343,1.443289 c -0.1201463,-0.03727 -0.2451954,-0.05709 -0.3712872,-0.05876 -0.7114931,5.53e-4 -1.2878856,0.560991 -1.2877013,1.252006 1.462e-4,0.690953 0.5769437,1.251052 1.2883754,1.25123 0.7114945,1.38e-4 1.2884997,-0.559622 1.2891124,-1.250635 a 1.271764,1.2351572 0 0 0 -0.060563,-0.36054 l 1.4696974,-1.42793 c 1.3132011,0.98184 3.1167931,1.066437 4.5213301,0.212061 1.404476,-0.854435 2.113273,-2.467456 1.776743,-4.0434463 C 14.752251,7.3109684 13.4415,6.1047456 11.802986,5.8631548 M 11.1938,11.640597 a 2.0332777,1.9747513 0 1 1 0,-3.9480734 c 1.094181,0.037209 1.961558,0.9092078 1.962172,1.9726087 4.39e-4,1.0632817 -0.865967,1.9361717 -1.96015,1.9744537"
        />
      </symbol>
      <symbol id="icon-facebook" viewBox="0 0 12 20">
        <path
          d="M10.9 1H8.2C7.00653 1 5.86193 1.47411 5.01802 2.31802C4.17411 3.16193 3.7 4.30653 3.7 5.5V8.2H1V11.8H3.7V19H7.3V11.8H10L10.9 8.2H7.3V5.5C7.3 5.26131 7.39482 5.03239 7.5636 4.8636C7.73239 4.69482 7.9613 4.6 8.2 4.6H10.9V1Z"
        />
      </symbol>
      <symbol id="icon-file-storage" viewBox="0 0 16 18">
        <path
          d="M8.8125 1H3.125C2.69402 1 2.2807 1.1712 1.97595 1.47595C1.6712 1.7807 1.5 2.19402 1.5 2.625V15.625C1.5 16.056 1.6712 16.4693 1.97595 16.774C2.2807 17.0788 2.69402 17.25 3.125 17.25H12.875C13.306 17.25 13.7193 17.0788 14.024 16.774C14.3288 16.4693 14.5 16.056 14.5 15.625V6.6875M8.8125 1L14.5 6.6875M8.8125 1V6.6875H14.5"
        />
      </symbol>
      <symbol id="icon-note" viewBox="0 0 14 14">
        <path
          d="M13 9C13 9.35362 12.8595 9.69276 12.6095 9.94281C12.3594 10.1929 12.0203 10.3333 11.6667 10.3333H3.66667L1 13V2.33333C1 1.97971 1.14048 1.64057 1.39052 1.39052C1.64057 1.14048 1.97971 1 2.33333 1H11.6667C12.0203 1 12.3594 1.14048 12.6095 1.39052C12.8595 1.64057 13 1.97971 13 2.33333V9Z"
        />
      </symbol>
      <symbol id="icon-filter" viewBox="0 0 16 12">
        <path d="M3.33333 6H12.6667M1 1.5H15M5.66667 10.5H10.3333" />
      </symbol>
      <symbol id="icon-general-401" viewBox="0 0 44 44">
        <path d="M22 42.5A20.5 20.5 0 1142.5 22 20.52 20.52 0 0122 42.5z" fill="#ccc" />
        <path
          d="M22 3A19 19 0 113 22 19 19 0 0122 3m0-3A22 22 0 000 22a22 22 0 0022 22 22 22 0 0022-22A22 22 0 0022 0z"
          fill="#3f3f3f"
        />
        <path
          d="M39.59 42.59a3 3 0 01-2.12-.88L2.29 6.54a3 3 0 014.25-4.25l35.17 35.17a3 3 0 01-2.12 5.12z"
          fill="#3f3f3f"
        />
        <path
          d="M4.41 2.41A2 2 0 015.83 3L41 38.17A2 2 0 1138.17 41L3 5.83a2 2 0 011.41-3.42m0-2a4 4 0 00-2.82 6.83l35.17 35.17a4 4 0 105.66-5.66L7.24 1.59A4 4 0 004.41.41z"
          fill="#fff"
        />
      </symbol>
      <symbol id="icon-general-404" viewBox="0 0 44 44">
        <path d="M22 42.5A20.5 20.5 0 1142.5 22 20.52 20.52 0 0122 42.5z" fill="#ccc" />
        <path
          d="M22 3A19 19 0 113 22 19 19 0 0122 3m0-3A22 22 0 000 22a22 22 0 0022 22 22 22 0 0022-22A22 22 0 0022 0z"
          fill="#3f3f3f"
        />
        <path d="M11.297 12.709l1.414-1.415 19.997 19.997-1.414 1.415z" opacity=".2" />
        <g fill="#3f3f3f">
          <path
            d="M13.86 26.64v-2.26H9.09V23l4.11-6.33h2.41v6.2H17v1.54h-1.38v2.26zm0-8.43l-3 4.62h3zM18 21.64c0-2.52 1.18-5.16 4-5.16s4 2.64 4 5.16-1.19 5.17-4 5.17-4-2.66-4-5.17zm6.21 0c0-1.92-.57-3.6-2.21-3.6s-2.22 1.68-2.22 3.6.58 3.62 2.22 3.62 2.21-1.71 2.21-3.62zM31.82 26.64v-2.26H27V23l4.11-6.33h2.41v6.2h1.33v1.54h-1.28v2.26zm0-8.43l-3 4.62h3z"
          />
        </g>
      </symbol>

      <symbol id="icon-google-adwords" viewBox="0 0 15 15">
        <rect
          x="4.21936"
          y="2.28955"
          width="4.61353"
          height="13.7781"
          rx="2.30677"
          transform="rotate(-29.3914 4.21936 2.28955)"
        />
        <rect x="6.5296" width="4.61353" height="13.7781" rx="2.30677" transform="rotate(28.279 6.5296 0)" />
        <rect
          x="2.18118"
          y="8.0791"
          width="4.61353"
          height="4.60392"
          rx="2.30196"
          transform="rotate(28.279 2.18118 8.0791)"
        />
      </symbol>

      <symbol id="icon-google-analytics" viewBox="0 0 16 16">
        <path
          d="m 15.510632,13.546707 c 0,1.017659 -0.920688,1.876619 -2.054695,1.876619 -0.07002,0 -0.176842,0 -0.246863,0 -1.063986,-0.128597 -1.844633,-0.984633 -1.807832,-1.939747 V 2.4150126 c -0.0368,-0.9548212 0.743846,-1.78104802 1.807832,-1.93974638 1.134006,-0.12859522 2.161517,0.60469118 2.304815,1.62234968 0,0.062833 0,0.1586984 0,0.2215348 V 13.546707 Z"
        />
        <path
          d="m 2.5024502,11.735849 c 1.1340068,0 2.054695,0.826226 2.054695,1.843885 0,1.017658 -0.9206882,1.843883 -2.054695,1.843883 -1.134006,0 -2.05469426,-0.826225 -2.05469426,-1.843883 C 0.41128002,12.562075 1.3684442,11.735849 2.5024502,11.735849 Z M 7.9259461,6.1057032 C 6.7919391,6.168545 5.9047957,7.0274999 5.9047957,8.0454505 v 4.9927205 c 0,1.335055 0.6738256,2.164203 1.6309894,2.352713 1.1340062,0.191433 2.1979927,-0.445993 2.4448551,-1.46365 0.036806,-0.128596 0.036806,-0.254562 0.036806,-0.383157 V 7.9764764 c 0,-1.0176576 -0.9206881,-1.8766178 -2.0546949,-1.8766178 h -0.036804 z"
        />
      </symbol>

      <symbol id="icon-join" viewBox="0 0 16 14">
        <rect x="1" y="1" width="4.88283" height="4.88283" rx="1" />
        <rect x="10.1172" y="1" width="4.88283" height="4.88283" rx="1" />
        <rect x="5.88283" y="8.16162" width="4.88283" height="4.88283" rx="2" />
        <path d="M3.76312 6.04541L3.76312 8.1613C3.76312 9.32988 4.71044 10.2772 5.87902 10.2772V10.2772" />
        <path d="M12.8777 6.04541L12.8777 8.1613C12.8777 9.32988 11.9304 10.2772 10.7619 10.2772V10.2772" />
      </symbol>
      <symbol id="icon-limit" viewBox="0 0 16 14">
        <path
          d="M2.90909 12.4545V8M2.90909 5.45455V1M8 12.4545V6.72727M8 4.18182V1M13.0909 12.4545V9.27273M13.0909 6.72727V1M1 8H4.81818M6.09091 4.18182H9.90909M11.1818 9.27273H15"
        />
      </symbol>
      <symbol id="icon-mongo" viewBox="0 0 14 22">
        <path
          d="M1.65281 12.4846C0.933938 10.0239 1.51054 7.36648 3.18461 5.42495L7 1L10.8154 5.42495C12.4895 7.36648 13.0661 10.0239 12.3472 12.4846V12.4846C11.8033 14.3464 10.5649 15.9281 8.88791 16.9028L7 18L5.11209 16.9028C3.43512 15.9281 2.19671 14.3464 1.65281 12.4846V12.4846Z"
        />
        <path d="M7.5 12L7.5 21.25" />
      </symbol>
      <symbol id="icon-most-popular">
        <path
          fill="#FFF"
          stroke="#0AB3E5"
          stroke-miterlimit="10"
          d="M37.8.7L45 8.6 55.1 5l2.8 10.4 10.6 1.5-2.4 10.4 8.7 6.2-6.9 8.2 4.7 9.6-9.9 4-.2 10.7-10.6-1.1-5.2 9.4-8.9-5.9-9 5.9-5.1-9.4L13 66l-.2-10.7-9.9-4 4.8-9.6-7-8.2 8.7-6.2-2.3-10.4 10.6-1.5L20.4 5l10.1 3.6z"
        />
        <g fill="#0AB3E5">
          <path
            d="M27.6 37.8l-4.7-5.9c.4 1 .8 1.9 1.1 2.8l1.4 3.9-1.3.4-2.8-8.1 1.9-.7 4.5 5.6.1-7.2 1.9-.7 2.8 8.1-1.3.4-1.4-4c-.1-.4-.3-.9-.5-1.6-.2-.7-.3-1-.4-1.2l-.1 7.6-1.2.6zM38.7 30.4c.3 1 .4 1.9.1 2.6-.3.7-.9 1.3-1.8 1.6-.6.2-1.1.2-1.7.1-.5-.1-1-.4-1.4-.8-.4-.4-.7-.9-.9-1.6-.3-1-.4-1.9-.1-2.6.3-.7.9-1.3 1.9-1.6.9-.3 1.7-.3 2.4.1.7.6 1.2 1.2 1.5 2.2zM34.3 32c.5 1.4 1.3 1.9 2.3 1.6 1-.4 1.3-1.2.8-2.7-.5-1.4-1.3-1.9-2.3-1.6-.5.2-.9.5-1 1-.1.4-.1 1 .2 1.7zM44.8 29.8c.2.6.2 1.1-.2 1.6-.3.5-.9.8-1.7 1.1-.8.3-1.5.4-2.1.3l-.4-1.1c.8.1 1.6 0 2.2-.2.8-.3 1.1-.7.9-1.1-.1-.2-.1-.3-.3-.3-.1-.1-.3-.1-.5-.2-.2 0-.6-.1-1-.1-.8 0-1.4-.1-1.7-.3-.3-.2-.6-.5-.7-.9-.2-.5-.1-1 .2-1.4.3-.4.8-.8 1.6-1 .7-.3 1.5-.3 2.2-.3l-.1 1.1c-.8 0-1.4 0-1.8.2-.7.2-1 .6-.8.9.1.2.2.3.4.4s.7.1 1.4.1c.6 0 1 .1 1.3.2.3.1.5.2.7.4.2 0 .3.3.4.6zM48.8 29.3c.3-.1.6-.3.9-.5l.3 1c-.1.1-.3.2-.5.4-.2.1-.4.2-.7.3-1.2.4-2.1 0-2.5-1.3l-1.2-3.3-.8.3-.2-.6.7-.8v-1.4l.8-.3.5 1.4 1.7-.6.3 1-1.7.6 1.1 3.3c.1.3.3.5.5.6.3 0 .5 0 .8-.1zM24 46.4c.3.8.2 1.6-.1 2.2-.4.6-1.1 1.1-2.1 1.5l-.8.3 1.1 3-1.4.6-2.8-8.1 2.3-.8c1-.4 1.8-.4 2.5-.2s1.1.7 1.3 1.5zm-3.5 3l.7-.2c.7-.2 1.1-.5 1.4-.9.2-.3.3-.8.1-1.3-.2-.5-.4-.8-.8-.9-.4-.1-.8-.1-1.4.1l-.9.3.9 2.9zM31.8 46.6c.3 1 .4 1.9.1 2.6-.3.7-.9 1.3-1.8 1.6-.6.2-1.1.2-1.7.1-.5-.1-1-.4-1.4-.8-.4-.4-.7-.9-.9-1.6-.3-1-.4-1.9 0-2.6.3-.7.9-1.3 1.9-1.6.9-.3 1.7-.3 2.4.1s1.1 1.2 1.4 2.2zm-4.4 1.6c.5 1.4 1.3 1.9 2.3 1.6 1-.4 1.3-1.2.8-2.7-.5-1.4-1.3-1.9-2.3-1.6-.5.2-.9.5-1 1-.1.4 0 1 .2 1.7zM37.6 48.2c-.8.3-1.5.2-2.1-.2h-.1c.2.5.4.8.4.9l.9 2.5-1.3.5-3.1-8.9 1.1-.4c.1.1.2.4.5.8h.1c.2-.8.7-1.3 1.5-1.6.8-.3 1.5-.2 2.1.2.6.4 1.1 1.1 1.5 2.1.3 1 .4 1.9.2 2.6-.5.7-1 1.2-1.7 1.5zM35.4 43c-.5.2-.8.5-1 .8-.1.4-.1.9.2 1.6l.1.2c.3.7.6 1.2.9 1.5s.8.3 1.3.1c.5-.2.7-.5.8-.9.1-.5.1-1-.2-1.7-.2-.7-.5-1.2-.9-1.4-.3-.3-.7-.4-1.2-.2zM45.8 45.2l-.5-.7h-.1c-.1.3-.3.7-.5.9-.3.3-.6.5-1.1.6-.7.3-1.4.3-1.9 0s-.9-.7-1.1-1.5l-1.4-4 1.3-.5 1.3 3.8c.2.5.4.8.7 1 .3.2.6.2 1 0 .5-.2.9-.5 1-.9s.1-1-.2-1.8l-1.1-3 1.3-.5 2.1 6.1-.8.5zM50 43.7l-1.3.5-3-8.6 1.3-.5 3 8.6zM55.6 41.7l-.6-.8c-.2.5-.4.8-.6 1.1-.3.2-.6.4-1.1.6-.6.2-1.1.2-1.6 0s-.8-.6-1-1.2c-.2-.6-.2-1.2.2-1.7s1-.9 2-1.3l1-.4-.1-.3c-.1-.4-.3-.7-.6-.8-.2-.1-.6-.1-1 0-.3.1-.6.3-.9.5-.3.2-.5.4-.7.6l-.6-.7c.3-.3.6-.5 1-.8.4-.2.7-.4 1.1-.5.8-.3 1.4-.3 1.9-.1.5.2.9.7 1.2 1.4l1.4 4.1-1 .3zm-2.2-.2c.5-.2.8-.4 1-.8.2-.4.2-.8 0-1.3l-.2-.5-.8.3c-.6.2-1 .5-1.2.8-.2.3-.3.6-.1 1 .1.3.2.5.5.5.2.1.5.1.8 0zM59.3 33.4c.3-.1.5-.1.7-.2l.3 1.3c-.2 0-.4.1-.6.1-.5.2-.9.5-1.1 1-.2.5-.2.9 0 1.5l1.1 3.2-1.3.5-2.1-6.1 1-.4.5 1h.1c.1-.4.2-.8.5-1.1s.5-.6.9-.8z"
          />
        </g>
        <g fill="#0AB3E5">
          <path
            d="M27.6 37.8l-4.7-5.9c.4 1 .8 1.9 1.1 2.8l1.4 3.9-1.3.4-2.8-8.1 1.9-.7 4.5 5.6.1-7.2 1.9-.7 2.8 8.1-1.3.4-1.4-4c-.1-.4-.3-.9-.5-1.6-.2-.7-.3-1-.4-1.2l-.1 7.6-1.2.6zM38.7 30.4c.3 1 .4 1.9.1 2.6-.3.7-.9 1.3-1.8 1.6-.6.2-1.1.2-1.7.1-.5-.1-1-.4-1.4-.8-.4-.4-.7-.9-.9-1.6-.3-1-.4-1.9-.1-2.6.3-.7.9-1.3 1.9-1.6.9-.3 1.7-.3 2.4.1.7.6 1.2 1.2 1.5 2.2zM34.3 32c.5 1.4 1.3 1.9 2.3 1.6 1-.4 1.3-1.2.8-2.7-.5-1.4-1.3-1.9-2.3-1.6-.5.2-.9.5-1 1-.1.4-.1 1 .2 1.7zM44.8 29.8c.2.6.2 1.1-.2 1.6-.3.5-.9.8-1.7 1.1-.8.3-1.5.4-2.1.3l-.4-1.1c.8.1 1.6 0 2.2-.2.8-.3 1.1-.7.9-1.1-.1-.2-.1-.3-.3-.3-.1-.1-.3-.1-.5-.2-.2 0-.6-.1-1-.1-.8 0-1.4-.1-1.7-.3-.3-.2-.6-.5-.7-.9-.2-.5-.1-1 .2-1.4.3-.4.8-.8 1.6-1 .7-.3 1.5-.3 2.2-.3l-.1 1.1c-.8 0-1.4 0-1.8.2-.7.2-1 .6-.8.9.1.2.2.3.4.4s.7.1 1.4.1c.6 0 1 .1 1.3.2.3.1.5.2.7.4.2 0 .3.3.4.6zM48.8 29.3c.3-.1.6-.3.9-.5l.3 1c-.1.1-.3.2-.5.4-.2.1-.4.2-.7.3-1.2.4-2.1 0-2.5-1.3l-1.2-3.3-.8.3-.2-.6.7-.8v-1.4l.8-.3.5 1.4 1.7-.6.3 1-1.7.6 1.1 3.3c.1.3.3.5.5.6.3 0 .5 0 .8-.1zM24 46.4c.3.8.2 1.6-.1 2.2-.4.6-1.1 1.1-2.1 1.5l-.8.3 1.1 3-1.4.6-2.8-8.1 2.3-.8c1-.4 1.8-.4 2.5-.2s1.1.7 1.3 1.5zm-3.5 3l.7-.2c.7-.2 1.1-.5 1.4-.9.2-.3.3-.8.1-1.3-.2-.5-.4-.8-.8-.9-.4-.1-.8-.1-1.4.1l-.9.3.9 2.9zM31.8 46.6c.3 1 .4 1.9.1 2.6-.3.7-.9 1.3-1.8 1.6-.6.2-1.1.2-1.7.1-.5-.1-1-.4-1.4-.8-.4-.4-.7-.9-.9-1.6-.3-1-.4-1.9 0-2.6.3-.7.9-1.3 1.9-1.6.9-.3 1.7-.3 2.4.1s1.1 1.2 1.4 2.2zm-4.4 1.6c.5 1.4 1.3 1.9 2.3 1.6 1-.4 1.3-1.2.8-2.7-.5-1.4-1.3-1.9-2.3-1.6-.5.2-.9.5-1 1-.1.4 0 1 .2 1.7zM37.6 48.2c-.8.3-1.5.2-2.1-.2h-.1c.2.5.4.8.4.9l.9 2.5-1.3.5-3.1-8.9 1.1-.4c.1.1.2.4.5.8h.1c.2-.8.7-1.3 1.5-1.6.8-.3 1.5-.2 2.1.2.6.4 1.1 1.1 1.5 2.1.3 1 .4 1.9.2 2.6-.5.7-1 1.2-1.7 1.5zM35.4 43c-.5.2-.8.5-1 .8-.1.4-.1.9.2 1.6l.1.2c.3.7.6 1.2.9 1.5s.8.3 1.3.1c.5-.2.7-.5.8-.9.1-.5.1-1-.2-1.7-.2-.7-.5-1.2-.9-1.4-.3-.3-.7-.4-1.2-.2zM45.8 45.2l-.5-.7h-.1c-.1.3-.3.7-.5.9-.3.3-.6.5-1.1.6-.7.3-1.4.3-1.9 0s-.9-.7-1.1-1.5l-1.4-4 1.3-.5 1.3 3.8c.2.5.4.8.7 1 .3.2.6.2 1 0 .5-.2.9-.5 1-.9s.1-1-.2-1.8l-1.1-3 1.3-.5 2.1 6.1-.8.5zM50 43.7l-1.3.5-3-8.6 1.3-.5 3 8.6zM55.6 41.7l-.6-.8c-.2.5-.4.8-.6 1.1-.3.2-.6.4-1.1.6-.6.2-1.1.2-1.6 0s-.8-.6-1-1.2c-.2-.6-.2-1.2.2-1.7s1-.9 2-1.3l1-.4-.1-.3c-.1-.4-.3-.7-.6-.8-.2-.1-.6-.1-1 0-.3.1-.6.3-.9.5-.3.2-.5.4-.7.6l-.6-.7c.3-.3.6-.5 1-.8.4-.2.7-.4 1.1-.5.8-.3 1.4-.3 1.9-.1.5.2.9.7 1.2 1.4l1.4 4.1-1 .3zm-2.2-.2c.5-.2.8-.4 1-.8.2-.4.2-.8 0-1.3l-.2-.5-.8.3c-.6.2-1 .5-1.2.8-.2.3-.3.6-.1 1 .1.3.2.5.5.5.2.1.5.1.8 0zM59.3 33.4c.3-.1.5-.1.7-.2l.3 1.3c-.2 0-.4.1-.6.1-.5.2-.9.5-1.1 1-.2.5-.2.9 0 1.5l1.1 3.2-1.3.5-2.1-6.1 1-.4.5 1h.1c.1-.4.2-.8.5-1.1s.5-.6.9-.8z"
          />
        </g>
        <g fill="#0AB3E5">
          <path
            d="M27.6 37.8l-4.7-5.9c.4 1 .8 1.9 1.1 2.8l1.4 3.9-1.3.4-2.8-8.1 1.9-.7 4.5 5.6.1-7.2 1.9-.7 2.8 8.1-1.3.4-1.4-4c-.1-.4-.3-.9-.5-1.6-.2-.7-.3-1-.4-1.2l-.1 7.6-1.2.6zM38.7 30.4c.3 1 .4 1.9.1 2.6-.3.7-.9 1.3-1.8 1.6-.6.2-1.1.2-1.7.1-.5-.1-1-.4-1.4-.8-.4-.4-.7-.9-.9-1.6-.3-1-.4-1.9-.1-2.6.3-.7.9-1.3 1.9-1.6.9-.3 1.7-.3 2.4.1.7.6 1.2 1.2 1.5 2.2zM34.3 32c.5 1.4 1.3 1.9 2.3 1.6 1-.4 1.3-1.2.8-2.7-.5-1.4-1.3-1.9-2.3-1.6-.5.2-.9.5-1 1-.1.4-.1 1 .2 1.7zM44.8 29.8c.2.6.2 1.1-.2 1.6-.3.5-.9.8-1.7 1.1-.8.3-1.5.4-2.1.3l-.4-1.1c.8.1 1.6 0 2.2-.2.8-.3 1.1-.7.9-1.1-.1-.2-.1-.3-.3-.3-.1-.1-.3-.1-.5-.2-.2 0-.6-.1-1-.1-.8 0-1.4-.1-1.7-.3-.3-.2-.6-.5-.7-.9-.2-.5-.1-1 .2-1.4.3-.4.8-.8 1.6-1 .7-.3 1.5-.3 2.2-.3l-.1 1.1c-.8 0-1.4 0-1.8.2-.7.2-1 .6-.8.9.1.2.2.3.4.4s.7.1 1.4.1c.6 0 1 .1 1.3.2.3.1.5.2.7.4.2 0 .3.3.4.6zM48.8 29.3c.3-.1.6-.3.9-.5l.3 1c-.1.1-.3.2-.5.4-.2.1-.4.2-.7.3-1.2.4-2.1 0-2.5-1.3l-1.2-3.3-.8.3-.2-.6.7-.8v-1.4l.8-.3.5 1.4 1.7-.6.3 1-1.7.6 1.1 3.3c.1.3.3.5.5.6.3 0 .5 0 .8-.1zM24 46.4c.3.8.2 1.6-.1 2.2-.4.6-1.1 1.1-2.1 1.5l-.8.3 1.1 3-1.4.6-2.8-8.1 2.3-.8c1-.4 1.8-.4 2.5-.2s1.1.7 1.3 1.5zm-3.5 3l.7-.2c.7-.2 1.1-.5 1.4-.9.2-.3.3-.8.1-1.3-.2-.5-.4-.8-.8-.9-.4-.1-.8-.1-1.4.1l-.9.3.9 2.9zM31.8 46.6c.3 1 .4 1.9.1 2.6-.3.7-.9 1.3-1.8 1.6-.6.2-1.1.2-1.7.1-.5-.1-1-.4-1.4-.8-.4-.4-.7-.9-.9-1.6-.3-1-.4-1.9 0-2.6.3-.7.9-1.3 1.9-1.6.9-.3 1.7-.3 2.4.1s1.1 1.2 1.4 2.2zm-4.4 1.6c.5 1.4 1.3 1.9 2.3 1.6 1-.4 1.3-1.2.8-2.7-.5-1.4-1.3-1.9-2.3-1.6-.5.2-.9.5-1 1-.1.4 0 1 .2 1.7zM37.6 48.2c-.8.3-1.5.2-2.1-.2h-.1c.2.5.4.8.4.9l.9 2.5-1.3.5-3.1-8.9 1.1-.4c.1.1.2.4.5.8h.1c.2-.8.7-1.3 1.5-1.6.8-.3 1.5-.2 2.1.2.6.4 1.1 1.1 1.5 2.1.3 1 .4 1.9.2 2.6-.5.7-1 1.2-1.7 1.5zM35.4 43c-.5.2-.8.5-1 .8-.1.4-.1.9.2 1.6l.1.2c.3.7.6 1.2.9 1.5s.8.3 1.3.1c.5-.2.7-.5.8-.9.1-.5.1-1-.2-1.7-.2-.7-.5-1.2-.9-1.4-.3-.3-.7-.4-1.2-.2zM45.8 45.2l-.5-.7h-.1c-.1.3-.3.7-.5.9-.3.3-.6.5-1.1.6-.7.3-1.4.3-1.9 0s-.9-.7-1.1-1.5l-1.4-4 1.3-.5 1.3 3.8c.2.5.4.8.7 1 .3.2.6.2 1 0 .5-.2.9-.5 1-.9s.1-1-.2-1.8l-1.1-3 1.3-.5 2.1 6.1-.8.5zM50 43.7l-1.3.5-3-8.6 1.3-.5 3 8.6zM55.6 41.7l-.6-.8c-.2.5-.4.8-.6 1.1-.3.2-.6.4-1.1.6-.6.2-1.1.2-1.6 0s-.8-.6-1-1.2c-.2-.6-.2-1.2.2-1.7s1-.9 2-1.3l1-.4-.1-.3c-.1-.4-.3-.7-.6-.8-.2-.1-.6-.1-1 0-.3.1-.6.3-.9.5-.3.2-.5.4-.7.6l-.6-.7c.3-.3.6-.5 1-.8.4-.2.7-.4 1.1-.5.8-.3 1.4-.3 1.9-.1.5.2.9.7 1.2 1.4l1.4 4.1-1 .3zm-2.2-.2c.5-.2.8-.4 1-.8.2-.4.2-.8 0-1.3l-.2-.5-.8.3c-.6.2-1 .5-1.2.8-.2.3-.3.6-.1 1 .1.3.2.5.5.5.2.1.5.1.8 0zM59.3 33.4c.3-.1.5-.1.7-.2l.3 1.3c-.2 0-.4.1-.6.1-.5.2-.9.5-1.1 1-.2.5-.2.9 0 1.5l1.1 3.2-1.3.5-2.1-6.1 1-.4.5 1h.1c.1-.4.2-.8.5-1.1s.5-.6.9-.8z"
          />
        </g>
      </symbol>
      <symbol id="icon-netsuite" viewBox="0 0 16 16">
        <rect x="1" y="1" width="14" height="14" />
        <path d="M5 11V5L11 11V5" />
      </symbol>
      <symbol id="icon-tiktokads" viewBox="0 0 16 16">
        <path
          d="M 11.588605,0.34092548 C 11.881658,2.4962578 13.294662,3.7805615 15.749219,3.9158487 V 6.3399025 C 14.326883,6.4585107 13.080004,6.0619149 11.631535,5.3150542 v 4.5330545 c 0,5.7562013 -7.3711359,7.5557083 -10.3334035,3.4285153 C -0.60578289,10.620914 0.55896501,5.9618391 6.6682917,5.7746607 V 8.3302955 C 6.2016456,8.3933058 5.7051347,8.4952349 5.2496884,8.6268159 3.8926823,9.0178518 3.1217836,9.7517401 3.3364408,11.045309 3.7470886,13.523108 9.085517,14.256995 8.6412699,9.4144479 V 0.34463198 h 2.9473351 z m 0,0"
        />
      </symbol>
      <symbol id="icon-notify-component">
        <style>
          .st1 {
            fill: #3f3f3f;
          }
        </style>
        <g id="icon-component-notify">
          <path d="M32 30c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h28c1.1 0 2 .9 2 2v28z" fill="#999" />
          <path class="st1" d="M7 13h2v5H7zM20 21l-10-3v-5l10-3zM21 13h3v2h-3zM21 16h3v2h-3z" />
        </g>
      </symbol>
      <symbol id="icon-packages">
        <path d="M31 28c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h23c1.7 0 3 1.3 3 3v23z" fill="#999" />
        <circle cx="25.1" cy="7.9" r="1.9" fill="#fff" />
        <path d="M16.5 11.7h-1.8c-.6 0-1-.4-1-1V2.1h3.8v8.6c0 .6-.5 1-1 1z" fill="#e6e6e6" />
      </symbol>
      <symbol id="icon-plus"><path fill="#3f3f3f" d="M26 14h-8V6h-4v8H6v4h8v8h4v-8h8z" /></symbol>
      <symbol id="icon-rank" viewBox="0 0 14 17">
        <path d="M13 16V7M7 16V1M1 16V11" stroke="#177AF0" />
      </symbol>
      <symbol id="icon-redo">
        <path
          d="M15.1 10.5h4.4v-8l12.1 12.1-12.1 12.1v-7.2h-4.4c-6.8 0-12.4 4.1-14 10.3-.3-1.2-.5-2.6-.5-3.9 0-8 6.5-15.4 14.5-15.4z"
          fill="none"
          stroke="#3f3f3f"
          stroke-miterlimit="10"
        />
      </symbol>
      <symbol id="icon-rest-api" viewBox="0 0 21 15">
        <path
          d="M10.4019 13.535L10.4019 7.53504M10.4019 7.53504L10.4019 0.926012L14.049 0.926012L14.049 7.53504L10.4019 7.53504Z"
        />
        <path d="M17.4019 13.535L17.4019 0.926012" />
        <path d="M3.20075 13.535L3.20075 0.926011L6.84786 0.926011L6.84786 13.535" />
        <path d="M3.95117 7.17578H6.45117" />
      </symbol>
      <symbol id="icon-run-package" viewBox="0 0 17 18">
        <path
          d="m 0.53389831,6.5224104 v 6.2449636 c 0,0.229174 0.44900398,0.458347 0.70557769,0.630226 l 6.8633466,4.010528 c 0.2565737,0.114587 0.5772908,0.114587 0.8338646,0 L 15.928321,13.3976 c 0.19243,-0.114587 0.641434,-0.343759 0.641434,-0.630226 V 6.5224104 L 8.5518266,10.819404 Z"
        />
        <path
          d="M 0.98290229,5.2046656 8.61597,9.3870729 16.249038,5.2046656 c 0.513147,-0.2864662 0.513147,-0.9739852 0,-1.2604515 L 9.4498346,0.62120562 c -0.5131474,-0.28646625 -1.1545817,-0.28646625 -1.6677291,0 L 0.98290229,4.0015073 c -0.51314741,0.2291731 -0.51314741,0.9166921 0,1.2031583 z"
        />
        <path
          d="M 9.513978,10.418352 8.5518266,10.819404 7.5896752,10.418352 v 6.760603 l 0.5131474,0.229173 c 0.2565737,0.114587 0.7055777,0.114587 0.898008,0 L 9.513978,17.178955 Z"
        />
      </symbol>
      <symbol id="icon-salesforce" viewBox="0 0 18 13">
        <path
          d="m 14.13322,2.3956122 c -0.742776,0 -1.371279,0.2393791 -1.942645,0.5984477 -0.34282,-1.3165849 -1.485553,-2.2741011 -2.7996952,-2.2741011 -0.9141861,0 -1.7140989,0.4189134 -2.2854652,1.1370505 C 6.5340483,0.83964833 5.5055889,0.18135593 4.3628563,0.18135593 c -1.7712355,0 -3.1996512,1.49611907 -3.1996512,3.35130677 0,0.7181372 0.2285465,1.4362744 0.6285029,1.9748773 -0.97132267,0.4787581 -1.65696224,1.5559639 -1.65696224,2.7528592 0,1.6756535 1.31414254,3.0520828 2.91396814,3.0520828 0.1714099,0 0.3999564,0 0.5713663,-0.05984 0.457093,1.017361 1.4855523,1.735499 2.628285,1.735499 1.3141425,0 2.3997384,-0.897672 2.7425582,-2.094567 0.457093,0.239379 0.9141861,0.418913 1.4855526,0.418913 1.028459,0 1.885509,-0.538603 2.399738,-1.3764293 0.399957,0.1795343 0.85705,0.2393793 1.314143,0.2393793 2.056918,0 3.713881,-1.7354985 3.713881,-3.88991 C 17.847101,4.1909552 16.190139,2.3956122 14.13322,2.3956122 Z"
        />
      </symbol>
      <symbol id="icon-sample" viewBox="0 0 16 16">
        <path
          d="M14.125 1.875L1.875 14.125M5.375 3.1875C5.375 4.39562 4.39562 5.375 3.1875 5.375C1.97938 5.375 1 4.39562 1 3.1875C1 1.97938 1.97938 1 3.1875 1C4.39562 1 5.375 1.97938 5.375 3.1875ZM15 12.8125C15 14.0206 14.0206 15 12.8125 15C11.6044 15 10.625 14.0206 10.625 12.8125C10.625 11.6044 11.6044 10.625 12.8125 10.625C14.0206 10.625 15 11.6044 15 12.8125Z"
        />
      </symbol>

      <symbol id="icon-select" viewBox="0 0 16 18">
        <path
          d="M11.8 1H2.2C1.53726 1 1 1.54505 1 2.21739V3.78261C1 4.45495 1.53726 5 2.2 5H11.8C12.4627 5 13 4.45495 13 3.78261V2.21739C13 1.54505 12.4627 1 11.8 1Z"
        />
        <path
          d="M13.8 7H4.2C3.53726 7 3 7.54505 3 8.21739V9.78261C3 10.455 3.53726 11 4.2 11H13.8C14.4627 11 15 10.455 15 9.78261V8.21739C15 7.54505 14.4627 7 13.8 7Z"
        />
        <path
          d="M11.8 13H2.2C1.53726 13 1 13.545 1 14.2174V15.7826C1 16.455 1.53726 17 2.2 17H11.8C12.4627 17 13 16.455 13 15.7826V14.2174C13 13.545 12.4627 13 11.8 13Z"
        />
      </symbol>
      <symbol id="icon-snowflake" viewBox="0 0 17 16">
        <path d="M6.14398 15.1867L8.14398 10.6001L10.144 15.1867" />
        <path d="M10.144 0.999816L8.14398 5.58643L6.14398 0.999816" />
        <path d="M1.00194 9.90805L5.97406 9.3468L3.00194 13.3722" />
        <path d="M15.286 6.27847L10.3139 6.83973L13.286 2.81437" />
        <path d="M2.99999 2.8146L5.97211 6.83996L0.999986 6.27871" />
        <path d="M13.286 13.3719L10.3139 9.34656L15.286 9.90782" />
      </symbol>
      <symbol id="icon-sort" viewBox="0 0 16 13">
        <path
          d="M15 8.88889L11.8889 12M11.8889 12L8.77778 8.88889M11.8889 12L11.8889 1.11111M0.888889 4.11111L4 1M4 1L7.11111 4.11111M4 1L4 11.8889"
        />
      </symbol>
      <symbol id="icon-sources" viewBox="0 0 9 16">
        <path
          d="M7.34613 12.5962L4.46151 15M4.46151 15L1.5769 12.5962M4.46151 15L4.46151 8.69231"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="1"
          y="1"
          width="6.92308"
          height="6.92308"
          rx="2"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-transformations" viewBox="0 0 17 12">
        <path
          d="M11 5.5L13.5 3M13.5 3L16 5.5M13.5 3V9C13.5 9.53043 13.2893 10.0391 12.9142 10.4142C12.5391 10.7893 12.0304 11 11.5 11H8"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6.5L3.5 9M3.5 9L1 6.5M3.5 9L3.5 3C3.5 2.46957 3.71071 1.96086 4.08579 1.58579C4.46086 1.21071 4.96957 1 5.5 1L9 1"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-destinations" viewBox="0 0 9 16">
        <path
          d="M7.34613 4.90377L4.46151 7.30762M4.46151 7.30762L1.5769 4.90377M4.46151 7.30762L4.46151 0.999923"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="1"
          y="8.30762"
          width="6.92308"
          height="6.92308"
          rx="2"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-analytical" viewBox="0 0 14 14">
        <line
          x1="0.75"
          y1="8.75"
          x2="0.75"
          y2="13.25"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line
          x1="12.75"
          y1="5.75"
          x2="12.75"
          y2="13.25"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line
          x1="6.75"
          y1="0.75"
          x2="6.75"
          y2="13.25"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-storage" viewBox="0 0 18 16">
        <path
          d="M15.5455 4.88889V15H2.45455V4.88889M7.54545 8H10.4545M1 1H17V4.88889H1V1Z"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-nosql" viewBox="0 0 16 16">
        <path
          d="M8 1V15M8 1H13.4444C13.857 1 14.2527 1.16389 14.5444 1.45561C14.8361 1.74733 15 2.143 15 2.55556V13.4444C15 13.857 14.8361 14.2527 14.5444 14.5444C14.2527 14.8361 13.857 15 13.4444 15H8V1ZM8 1H2.55556C2.143 1 1.74733 1.16389 1.45561 1.45561C1.16389 1.74733 1 2.143 1 2.55556V13.4444C1 13.857 1.16389 14.2527 1.45561 14.5444C1.74733 14.8361 2.143 15 2.55556 15H8V1Z"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-objectstorage" viewBox="0 0 19 14">
        <path
          d="M13.5655 5.43334H12.6345C12.3581 4.36269 11.7869 3.39104 10.9858 2.62881C10.1847 1.86657 9.18593 1.34432 8.10287 1.12138C7.01981 0.898448 5.89594 0.983774 4.85895 1.36767C3.82196 1.75156 2.91344 2.41862 2.23662 3.29306C1.55981 4.1675 1.14184 5.21424 1.0302 6.31436C0.91857 7.41448 1.11775 8.52385 1.60511 9.51642C2.09247 10.509 2.84847 11.345 3.78721 11.9293C4.72594 12.5137 5.80977 12.8231 6.91553 12.8222H13.5655C14.5454 12.8222 15.4851 12.433 16.1779 11.7402C16.8708 11.0473 17.26 10.1076 17.26 9.1278C17.26 8.14797 16.8708 7.20827 16.1779 6.51542C15.4851 5.82258 14.5454 5.43334 13.5655 5.43334Z"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-relational" viewBox="0 0 18 14">
        <rect
          x="1"
          y="8"
          width="5"
          height="5"
          rx="1"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="12"
          y="8"
          width="5"
          height="5"
          rx="1"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5 8V5C14.5 4.44772 14.0523 4 13.5 4H4.5C3.94772 4 3.5 4.44772 3.5 5V8"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line
          x1="9.25"
          y1="0.75"
          x2="9.25"
          y2="3.25"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-services" viewBox="0 0 18 15">
        <rect
          x="1"
          y="11"
          width="16"
          height="3"
          rx="1"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 10C15 6.68629 12.3137 4 9 4C5.68629 4 3 6.68629 3 10"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line
          x1="9.25"
          y1="1.75"
          x2="9.25"
          y2="3.25"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line
          x1="7.75"
          y1="1.25"
          x2="10.75"
          y2="1.25"
          stroke="#3D4651"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-spanner" viewBox="0 0 18 15">
        <path d="M16.5 7.5L12.75 13.9952L5.25 13.9952L1.5 7.5L5.25 1.00481L12.75 1.00481L16.5 7.5Z" />
        <line x1="9.03884" y1="7.45747" x2="11.2139" y2="8.68998" />
        <path d="M11.2502 10.1473L10.9964 8.56676L12.4827 7.97224" />
        <line
          x1="0.75"
          y1="-0.75"
          x2="3.25"
          y2="-0.75"
          transform="matrix(-0.870026 0.493006 0.493006 0.870026 10.0846 7.73975)"
        />
        <path d="M6.73251 10.1468L6.98628 8.56628L5.5 7.97175" />
        <line x1="9.07858" y1="7.25" x2="9.07858" y2="4.75" />
        <path d="M10.3286 4L9.07858 5L7.82858 4" />
      </symbol>
      <symbol id="icon-test"><path d="M26 6v20H6V6h20m5-5H1v30h30V1z" fill="#3f3f3f" /></symbol>
      <symbol id="icon-undo">
        <path
          d="M18.2 11.5h-5.7V3.8L1.4 14.9 12.5 26v-7.4h5.7c6.2 0 11.4 4.1 12.9 9.9.3-1.1.4-2 .4-3.1 0-7.5-5.9-13.9-13.3-13.9z"
          fill="none"
          stroke="#3f3f3f"
          stroke-miterlimit="10"
        />
      </symbol>
      <symbol id="icon-union" viewBox="0 0 14 14">
        <path
          d="M10.9486 9.25L7.10217 13M7.10217 13L3.25576 9.25M7.10217 13V6C7.10217 3.23858 9.34075 1 12.1022 1H13"
        />
        <path d="M1 1H2.15426C4.91568 1 7.15426 3.23858 7.15426 6V7" />
      </symbol>
      <symbol id="icon-window" viewBox="0 0 16 16">
        <path d="M1 3L15 1V15L1 13V3Z" />
        <line x1="6.75" y1="2.75" x2="6.75" y2="13.25" />
        <line x1="1.75" y1="8.25" x2="14.25" y2="8.25" />
      </symbol>
      <symbol id="icon-xplenty">
        <path fill="#FFF" d="M15 29.2C7.2 29.2.8 22.8.8 15S7.2.8 15 .8 29.2 7.2 29.2 15 22.8 29.2 15 29.2z" />
        <path
          fill="#3F3F3F"
          d="M15 1.7c7.4 0 13.3 6 13.3 13.3S22.4 28.3 15 28.3 1.7 22.4 1.7 15 7.6 1.7 15 1.7M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.2 0 15 0z"
        />
        <path
          fill="#0AB3E5"
          d="M8.7 14l2.7 2.2 3.8-6.1 4.8 7.6 2.6-2 2.9 4.2c.7-1.5 1.2-3.3 1.2-5 0-6.5-5.1-11.6-11.6-11.6S3.3 8.5 3.3 14.9c0 2 .5 3.7 1.4 5.5l4-6.4z"
        />
      </symbol>
      <symbol id="icon-info" viewBox="0 0 16 16">
        <path
          d="M8 10.8V8M8 5.2H8.007M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
          stroke="#177AF0"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="transparent"
        />
      </symbol>
      <symbol id="clustercat-holding-head" viewBox="0 0 38 42">
        <path
          fill="#0ca3e5"
          class="path1"
          d="M27.702 29.976c0.025-0.184 0.047-0.351 0.067-0.512-0.676-0.139-0.738-1.228-0.799-4.009 0-0.543-0.022-1.052-0.047-1.37-0.111-1.542-0.231-3.037-0.362-4.454-0.134-1.448-0.278-2.837-0.431-4.131-0.067-0.556-0.151-1.035-0.258-1.505-0.096-0.41-0.232-0.942-0.394-1.485s-0.326-1.041-0.496-1.503c-0.050-0.134-0.097-0.259-0.145-0.381h-0.086c-0.154-0.002-0.297-0.047-0.418-0.124-0.049-0.030-0.093-0.062-0.135-0.097-0.272-0.227-0.451-0.56-0.474-0.936-0.156-2.715 0.52-5.059 1.91-8.703 0.006-0.017 0.010-0.036 0.010-0.056 0-0.037-0.012-0.071-0.032-0.098-0.019-0.030-0.051-0.051-0.088-0.055l-0.017-0c-1.564 0.187-3.908 1.64-6.575 4.087l-0.278 0.278-0.367-0.189c-0.198-0.106-0.379-0.2-0.557-0.278-0.604-0.257-1.305-0.453-2.037-0.552q-0.043 0.031-0.043 0.070c-0.075 0.626-0.888 0.626-1.322 0.626-0.173 0-0.354 0-0.532-0.019-0.020-0-0.045-0-0.069-0-0.488 0-0.971 0.024-1.447 0.072-0.598 0.085-1.163 0.197-1.718 0.339-0.594 0.144-1.351 0.355-2.084 0.586-0.479 0.153-0.963 0.317-1.434 0.496l-0.306 0.111-0.251-0.214c-2.386-2.021-4.359-3.199-5.724-3.199v0c-0.009 0.001-0.017 0.008-0.019 0.017 0.579 1.364 1.14 3.032 1.583 4.748 0.16 0.709 0.22 1.224 0.22 1.753 0 1.019-0.22 1.986-0.615 2.858l0.018-0.030c-0.336 0.739-0.654 1.628-0.901 2.546-0.17 0.627-0.303 1.259-0.399 1.903 0.338 0.191 0.608 0.456 0.713 0.794 0.133 0.342 0.378 3.006 0.478 4.133 0.081 0.924 0.159 1.912 0.231 3.018 0.064 0.966 0.131 2.041 0.2 3.285 0.064 1.144 0.125 2.341 0.189 3.597 0 0.2 0.019 0.401 0.031 0.604h25.007c0.061-0.874 0.131-1.489 0.203-2.018z"
        ></path>
        <path
          fill="#002e40"
          class="path2"
          d="M2.183 31.41c-0.064-1.256-0.125-2.453-0.189-3.597-0.070-1.239-0.134-2.313-0.2-3.282-0.075-1.114-0.15-2.088-0.231-3.012-0.036-0.379-0.334-3.725-0.448-4.050-0.080-0.265-0.288-0.468-0.551-0.539-0.049-0.012-0.1-0.018-0.151-0.018-0.002 0-0.003 0-0.005 0h-0.092c0-0.078 0.020-0.164 0.033-0.262 0.108-0.763 0.245-1.423 0.42-2.067 0.253-0.943 0.575-1.845 0.963-2.713 0.319-0.682 0.533-1.617 0.533-2.601 0-0.499-0.055-0.985-0.159-1.453-0.49-1.918-1.047-3.572-1.712-5.171 0.081 0.22 0.074 0.187 0.074 0.152 0-0.058 0.018-0.113 0.049-0.157 0.049-0.081 0.138-0.135 0.239-0.135 0.002 0 0.004 0 0.006 0 1.442 0.075 3.474 1.191 5.896 3.232l0.125 0.109 0.153-0.058c0.476-0.178 0.963-0.348 1.448-0.501 0.741-0.234 1.506-0.448 2.21-0.615 0.456-0.121 1.033-0.235 1.621-0.316 0.505-0.052 0.996-0.077 1.493-0.077 0.034 0 0.068 0 0.101 0 0.151-0 0.337 0.019 0.507 0.019 0.618 0 1.008-0.064 1.047-0.381 0.002-0.014 0.003-0.030 0.003-0.046 0-0.134-0.076-0.251-0.188-0.309 0.972 0.052 1.882 0.273 2.716 0.634 0.124 0.064 0.313 0.161 0.522 0.273l0.173 0.092 0.145-0.134c1.576-1.428 4.543-3.883 6.742-4.148h0.047c0.135 0.002 0.253 0.071 0.322 0.177 0.048 0.071 0.076 0.156 0.076 0.247 0 0.058-0.011 0.113-0.031 0.163-1.374 3.616-2.045 5.921-1.892 8.582 0.013 0.299 0.15 0.563 0.361 0.745 0.032 0.027 0.067 0.052 0.103 0.074 0.082 0.054 0.179 0.085 0.282 0.086 0.003 0 0.007 0 0.010 0 0.088 0 0.17-0.028 0.236-0.076q0.121 0.279 0.247 0.636c0.173 0.465 0.345 0.988 0.501 1.52s0.301 1.086 0.418 1.598c0.094 0.385 0.184 0.877 0.248 1.378 0.161 1.362 0.305 2.754 0.439 4.209s0.253 2.909 0.362 4.454c0.022 0.323 0.033 0.835 0.047 1.392 0.067 2.951 0.159 3.75 0.685 3.75 0 0 0 0 0 0 0.053 0 0.104-0.011 0.15-0.032-0.025 0.279-0.061 0.558-0.103 0.836-0.070 0.521-0.15 1.114-0.2 1.988h0.278c0.111-1.932 0.384-2.547 0.315-3.842-0.187 0.54-0.328 0.763-0.44 0.763-0.448 0-0.365-3.65-0.454-4.874q-0.164-2.297-0.362-4.454c-0.134-1.436-0.278-2.82-0.431-4.145-0.074-0.585-0.166-1.087-0.282-1.58-0.097-0.428-0.242-0.979-0.4-1.516s-0.331-1.063-0.507-1.537c-0.184-0.512-0.359-0.92-0.553-1.318 0.002 0.43-0.082 0.575-0.202 0.575-0.050-0.006-0.095-0.026-0.131-0.056l-0.072-0.053c-0.156-0.137-0.255-0.335-0.262-0.556-0.153-2.629 0.537-4.942 1.887-8.45 0.030-0.076 0.048-0.164 0.048-0.256 0-0.386-0.309-0.7-0.693-0.707h-0.081c-2.227 0.278-5.164 2.642-6.896 4.229-0.2-0.106-0.398-0.192-0.601-0.278-0.878-0.383-1.9-0.612-2.974-0.624l-0.005-0c-0.024-0-0.053-0-0.081-0-0.388 0-0.769 0.030-1.141 0.086 1.99 0.476 1.389 0.621 0.571 0.621-0.17 0-0.348 0-0.515-0.025-0.036-0-0.078-0-0.121-0-0.499 0-0.992 0.024-1.478 0.072-0.622 0.087-1.21 0.203-1.787 0.35-0.576 0.14-1.345 0.352-2.116 0.597-0.493 0.156-0.985 0.326-1.462 0.504-1.796-1.509-4.192-3.199-6.046-3.304h-0.031c-0.006-0-0.013-0-0.020-0-0.307 0-0.557 0.249-0.557 0.557 0 0.076 0.015 0.149 0.043 0.216 0.566 1.335 1.118 2.978 1.556 4.666 0.153 0.673 0.208 1.147 0.208 1.634 0 0.934-0.202 1.821-0.565 2.619l0.016-0.026c-0.346 0.762-0.673 1.679-0.928 2.626-0.181 0.662-0.323 1.328-0.425 2.008-0.089 0.57-0.089 0.845-0.089 0.845 0.046-0.041 0.097-0.078 0.152-0.109 0.079-0.045 0.167-0.072 0.262-0.075 0.014-0.002 0.029-0.003 0.044-0.003s0.030 0.001 0.045 0.003c0.167 0.063 0.293 0.206 0.332 0.38 0.101 0.248 0.363 3.016 0.446 3.976s0.161 1.949 0.231 3.007 0.136 2.135 0.2 3.279 0.125 2.338 0.189 3.594c0 0.189 0.020 0.384 0.028 0.576h0.278c-0.006-0.198-0.017-0.395-0.025-0.59z"
        ></path>
        <path
          fill="#002e40"
          class="path3"
          d="M28.078 29.169c-0.043 0.019-0.094 0.031-0.147 0.031-0 0-0 0-0 0-0.523 0-0.618-0.799-0.685-3.75 0-0.557-0.022-1.061-0.047-1.392-0.111-1.537-0.231-3.034-0.362-4.454s-0.278-2.848-0.431-4.137c-0.072-0.573-0.162-1.066-0.276-1.549-0.095-0.413-0.236-0.954-0.398-1.499s-0.331-1.055-0.501-1.52q-0.125-0.342-0.248-0.635c-0.065 0.047-0.147 0.075-0.235 0.075-0.004 0-0.007-0-0.011-0-0.103-0.001-0.199-0.032-0.28-0.085-0.037-0.023-0.071-0.048-0.102-0.075-0.21-0.182-0.347-0.446-0.36-0.743-0.145-2.647 0.526-4.966 1.896-8.574 0.018-0.047 0.029-0.101 0.029-0.157 0-0.094-0.030-0.182-0.080-0.254-0.068-0.103-0.184-0.171-0.316-0.174h-0.048c-2.196 0.262-5.167 2.717-6.74 4.156l-0.145 0.134-0.173-0.092c-0.209-0.111-0.395-0.212-0.573-0.292-0.782-0.343-1.69-0.566-2.643-0.62 0.093 0.058 0.169 0.175 0.169 0.309 0 0.016-0.001 0.033-0.003 0.048-0.039 0.316-0.428 0.38-1.046 0.38-0.173 0-0.356 0-0.512-0.019-0.029-0-0.062-0-0.096-0-0.496 0-0.987 0.024-1.471 0.072-0.616 0.086-1.2 0.201-1.771 0.347-0.595 0.143-1.361 0.358-2.101 0.592-0.484 0.153-0.969 0.32-1.448 0.501l-0.139 0.053-0.125-0.106c-2.422-2.035-4.454-3.154-5.896-3.235-0.003-0-0.007-0-0.011-0-0.098 0-0.184 0.051-0.234 0.127-0.031 0.045-0.049 0.099-0.049 0.157 0 0.035 0.006 0.068 0.018 0.099 0.573 1.351 1.13 3.008 1.571 4.712 0.156 0.69 0.212 1.183 0.212 1.689 0 0.983-0.213 1.916-0.595 2.756-0.324 0.709-0.646 1.612-0.897 2.544-0.177 0.655-0.314 1.314-0.411 1.986-0.011 0.185-0.036 0.275-0.044 0.352h0.092c0.001 0 0.003 0 0.004 0 0.052 0 0.102 0.006 0.15 0.018 0.258 0.070 0.463 0.265 0.545 0.517 0.116 0.331 0.414 3.677 0.447 4.056 0.081 0.924 0.156 1.91 0.231 3.012 0.067 0.972 0.131 2.043 0.2 3.282 0.064 1.144 0.125 2.341 0.189 3.597 0 0.195 0.019 0.393 0.028 0.59h0.278c0-0.203-0.019-0.404-0.031-0.604-0.064-1.256-0.125-2.453-0.189-3.597-0.070-1.247-0.136-2.322-0.2-3.285-0.075-1.114-0.15-2.093-0.231-3.018-0.097-1.13-0.342-3.794-0.473-4.128-0.107-0.345-0.378-0.611-0.719-0.708 0.1-0.737 0.233-1.369 0.401-1.986 0.25-0.929 0.569-1.818 0.951-2.673l-0.046 0.101c0.377-0.828 0.597-1.795 0.597-2.814 0-0.529-0.059-1.044-0.171-1.539-0.49-1.931-1.052-3.6-1.722-5.212 0.094 0.239 0.101 0.232 0.111 0.231h0c1.364 0 3.341 1.178 5.715 3.176l0.251 0.214 0.306-0.111c0.47-0.178 0.952-0.342 1.434-0.496 0.732-0.231 1.492-0.443 2.191-0.61 0.447-0.119 1.013-0.231 1.589-0.311 0.497-0.052 0.98-0.076 1.468-0.076 0.024 0 0.048 0 0.073 0 0.174 0 0.355 0.019 0.528 0.019 0.437 0 1.247 0 1.322-0.626q0-0.039 0-0.075c0.775 0.104 1.476 0.299 2.134 0.577 0.127 0.063 0.305 0.158 0.502 0.258l0.348 0.187 0.278-0.278c2.695-2.419 5.039-3.872 6.603-4.059h0.017c0.040 0.002 0.074 0.024 0.094 0.055 0.019 0.027 0.030 0.059 0.030 0.094 0 0.020-0.004 0.040-0.010 0.058-1.392 3.643-2.068 5.987-1.909 8.698 0.019 0.378 0.193 0.713 0.46 0.942 0.042 0.035 0.086 0.067 0.133 0.096 0.123 0.078 0.266 0.124 0.419 0.125h0.087c0.047 0.123 0.097 0.251 0.145 0.381 0.17 0.462 0.342 0.98 0.496 1.503s0.298 1.075 0.423 1.581c0.093 0.377 0.182 0.86 0.246 1.35 0.161 1.364 0.306 2.756 0.439 4.203 0.131 1.392 0.251 2.901 0.362 4.454 0.022 0.317 0.033 0.835 0.047 1.37 0.061 2.784 0.122 3.869 0.799 4.009-0.020 0.161-0.042 0.331-0.067 0.512-0.072 0.529-0.153 1.144-0.203 2.024h0.278c0.050-0.863 0.131-1.467 0.2-1.988 0.028-0.312 0.064-0.582 0.086-0.857z"
        ></path>
        <path
          opacity="0.8"
          fill="#002e40"
          class="path4"
          d="M20.703 4.677c0.727-0.682 2.244-1.965 3.165-1.718-0.521 1.336-0.835 2.227-0.849 3.154-0.014 0.185-0.168 0.33-0.355 0.33-0.068 0-0.132-0.019-0.186-0.053l-1.697-1.026c-0.126-0.079-0.209-0.217-0.209-0.374 0-0.123 0.050-0.233 0.131-0.313z"
        ></path>
        <path
          fill="#7acefe"
          class="path5"
          d="M13.844 9.362c-0.3 0-0.596 0.018-0.887 0.054-2.613 0.321-4.786 2.065-5.719 4.433-0.122 0.32-0.184 0.635-0.184 0.964 0 1.428 1.154 2.587 2.58 2.594 0.064 0 0.139 0.001 0.213 0.001 2.935 0 5.785-0.368 8.505-1.060 0.908-0.236 1.744-1.258 1.744-2.474 0-0.548-0.169-1.056-0.459-1.475-1.283-1.841-3.398-3.036-5.793-3.037z"
        ></path>
        <path
          opacity="0.1"
          fill="#002e40"
          class="path6"
          d="M7.444 8.928c-0 0-0.001 0-0.001 0-0.231 0-0.418-0.187-0.418-0.418 0-0.133 0.062-0.251 0.159-0.328 1.511-1.205 3.382-2.021 5.428-2.267l0.38-0.038 0.329-0.031h0.32c0.1-0.003 0.218-0.005 0.336-0.005 1.868 0 3.625 0.473 5.158 1.306 0.076 0.043 0.165 0.182 0.165 0.341 0 0.231-0.187 0.418-0.418 0.418-0.072 0-0.139-0.018-0.198-0.050-1.361-0.742-2.983-1.178-4.707-1.178-0.106 0-0.212 0.002-0.317 0.005l-0.296-0-0.303 0.022-0.303 0.031c-1.937 0.233-3.664 0.986-5.078 2.115-0.048 0.041-0.136 0.076-0.233 0.079z"
        ></path>
        <path
          fill="#002e40"
          class="path7"
          d="M11.787 13.195c0 0.441-0.358 0.799-0.799 0.799s-0.799-0.358-0.799-0.799c0-0.441 0.358-0.799 0.799-0.799s0.799 0.358 0.799 0.799z"
        ></path>
        <path
          fill="#002e40"
          class="path8"
          d="M16.182 12.797c0 0.441-0.358 0.799-0.799 0.799s-0.799-0.358-0.799-0.799c0-0.441 0.358-0.799 0.799-0.799s0.799 0.358 0.799 0.799z"
        ></path>
        <path
          fill="#ffd261"
          class="path9"
          d="M11.815 17.34c-0.085-0.083-0.138-0.199-0.138-0.328 0-0.238 0.182-0.434 0.414-0.457l3.248-0.253c0 0 0 0 0.001 0 0.254 0 0.459 0.206 0.459 0.459 0 0.103-0.034 0.198-0.091 0.274l-1.767 2.426z"
        ></path>
        <path
          fill="#002e40"
          class="path10"
          d="M17.162 22.245c-0.606-0.94-1.647-1.554-2.83-1.559l-0.101-1.147 0.131-0.178 1.578-2.166c0.090-0.121 0.143-0.273 0.143-0.437 0-0.407-0.33-0.738-0.738-0.738-0.001 0-0.001 0-0.002 0h-0.064l-3.199 0.253c-0.385 0.027-0.687 0.346-0.687 0.736 0 0.207 0.085 0.394 0.222 0.528l2.057 2.049 0.1 1.144c-1.16 0.188-2.109 0.941-2.566 1.963-0.027 0.058-0.038 0.101-0.038 0.146 0 0.123 0.080 0.228 0.192 0.265 0.024 0.007 0.050 0.011 0.077 0.011 0.112 0 0.209-0.066 0.253-0.162 0.444-1.026 1.446-1.73 2.612-1.73 1.006 0 1.889 0.523 2.393 1.313 0.058 0.086 0.142 0.134 0.238 0.134 0.047 0 0.091-0.012 0.13-0.032 0.085-0.047 0.143-0.139 0.143-0.244 0-0.056-0.017-0.108-0.045-0.152zM12.009 17.146c-0.035-0.033-0.056-0.080-0.056-0.131 0-0.096 0.075-0.175 0.17-0.181l3.216-0.253c0.097 0.004 0.173 0.084 0.173 0.181 0 0.036-0.011 0.070-0.029 0.098l-1.564 2.176z"
        ></path>
        <path
          fill="#002e40"
          class="path11"
          d="M5.011 18.543c-0.154-0-0.278-0.125-0.278-0.278 0-0.114 0.069-0.213 0.167-0.255 0.122-0.054 2.989-1.265 5.505-0.853 0.135 0.022 0.237 0.138 0.237 0.278 0 0.156-0.126 0.282-0.282 0.282-0.016 0-0.031-0.001-0.046-0.004-2.356-0.387-5.165 0.802-5.193 0.813s-0.062 0.017-0.096 0.017c-0.005 0-0.011-0-0.016-0z"
        ></path>
        <path
          fill="#002e40"
          class="path12"
          d="M7.355 20.489c-0.002 0-0.004 0-0.006 0-0.154 0-0.278-0.125-0.278-0.278 0-0.063 0.021-0.121 0.056-0.168 0.038-0.055 0.96-1.341 3.087-1.341h0.086c0.154 0 0.278 0.125 0.278 0.278s-0.125 0.278-0.278 0.278c-1.882-0.039-2.678 1.058-2.711 1.114-0.051 0.071-0.134 0.117-0.227 0.117-0.002 0-0.005-0-0.007-0z"
        ></path>
        <path
          fill="#002e40"
          class="path13"
          d="M17.354 17.215c-0.154-0-0.278-0.125-0.278-0.278 0-0.12 0.076-0.222 0.181-0.261 1.53-0.495 3.312-0.857 5.152-1.016 0.098-0.007 0.105-0.007 0.113-0.007 0.154 0 0.279 0.125 0.279 0.279 0 0.147-0.113 0.267-0.257 0.278-1.885 0.166-3.621 0.518-5.28 1.041 0.15-0.040 0.123-0.036 0.095-0.036-0.002 0-0.004-0-0.006-0z"
        ></path>
        <path
          fill="#002e40"
          class="path14"
          d="M20.971 18.93c-0.041-0.001-0.079-0.010-0.113-0.026l0.002 0.001s-1.219-0.521-3.132-0.175c-0.015 0.003-0.032 0.004-0.050 0.004-0.156 0-0.283-0.127-0.283-0.283 0-0.139 0.1-0.254 0.231-0.278 2.095-0.357 3.404 0.2 3.459 0.228 0.094 0.046 0.157 0.141 0.157 0.251 0 0.151-0.121 0.274-0.271 0.278z"
        ></path>
        <path
          opacity="0.8"
          fill="#002e40"
          class="path15"
          d="M5.454 6.481c-0.61-0.576-2.255-2.027-3.207-1.748 0.54 1.328 0.835 2.188 0.86 3.123 0 0.001-0 0.002-0 0.003 0 0.141 0.115 0.256 0.256 0.256 0.051 0 0.098-0.015 0.137-0.040l1.909-1.194c0.073-0.046 0.121-0.126 0.121-0.218 0-0.072-0.029-0.136-0.077-0.183z"
        ></path>
      </symbol>
      <symbol id="clustercat-holding-hand" viewBox="0 0 290 290">
        <path
          fill="#fff"
          class="path1"
          d="M15.059 20.329c0 3.388-2.635 6.024-6.024 6.024h-1.129c-3.388 0-6.024-2.635-6.024-6.024v-10.541c0-3.388 2.635-6.024 6.024-6.024h0.941c3.576 0 6.212 2.635 6.212 6.024v10.541z"
        ></path>
        <path
          fill="#fff"
          class="path2"
          d="M43.294 20.329c0 3.388-2.635 6.024-6.024 6.024h-0.941c-3.388 0-6.024-2.635-6.024-6.024v-10.541c-0.188-3.388 2.447-6.024 5.835-6.024h0.941c3.576 0 6.212 2.635 6.212 6.024v10.541z"
        ></path>
        <path
          fill="#fff"
          class="path3"
          d="M30.118 22.965c0 3.953-3.2 7.153-7.153 7.153h-0.941c-3.765 0-6.965-3.2-6.965-7.153v-13.929c0-3.953 3.2-7.153 7.153-7.153h0.941c3.765 0 6.965 3.2 6.965 7.153v13.929z"
        ></path>
        <path
          fill="#002e40"
          class="path4"
          d="M37.271 1.882h-0.941c-2.259 0-4.141 0.941-5.647 2.259-1.506-2.447-4.329-4.141-7.529-4.141h-0.941c-3.2 0-6.024 1.694-7.529 4.141-1.506-1.318-3.576-2.259-5.647-2.259h-1.129c-4.329 0-7.906 3.576-7.906 7.906v10.353c0 4.518 3.576 8.094 7.906 8.094h0.941c1.882 0 3.576-0.753 4.894-1.694 1.318 3.2 4.518 5.459 8.282 5.459h0.941c3.765 0 6.965-2.259 8.282-5.459 1.318 1.129 3.012 1.694 4.894 1.694h0.941c4.329 0 7.906-3.576 7.906-7.906v-10.541c0.188-4.329-3.388-7.906-7.718-7.906zM9.035 24.471h-1.129c-2.259 0-4.141-1.882-4.141-4.141v-10.541c0-2.259 1.882-4.141 4.141-4.141h0.941c2.447 0 4.329 1.882 4.329 4.141v10.353c0 2.447-1.882 4.329-4.141 4.329zM28.235 22.965c0 2.824-2.259 5.271-5.271 5.271h-0.941c-2.824 0-5.082-2.259-5.082-5.271v-13.929c0-3.012 2.259-5.271 5.271-5.271h0.941c2.824 0 5.082 2.259 5.082 5.271v13.929zM41.412 20.329c0 2.259-1.882 4.141-4.141 4.141h-0.941c-2.447 0-4.329-1.882-4.329-4.141v-10.541c0-2.259 1.882-4.141 4.141-4.141h0.941c2.447 0 4.329 1.882 4.329 4.141v10.541z"
        ></path>
      </symbol>
      <symbol id="icon-book" viewBox="0 0 25 32">
        <path
          d="M24.889 7.111h-21.582c-1.842-0.068-3.309-1.577-3.309-3.429 0-0.045 0.001-0.089 0.003-0.133l-0 24.895c0 1.964 1.592 3.556 3.556 3.556h21.333v-24.889z"
        ></path>
        <path
          fill="#fff"
          d="M3.307 6.222c-1.352-0.076-2.42-1.192-2.42-2.556 0-0.039 0.001-0.078 0.003-0.116-0.002-0.027-0.003-0.066-0.003-0.105 0-1.365 1.068-2.48 2.413-2.556l19.811-0c-0.555 0.725-0.889 1.645-0.889 2.643 0 0.008 0 0.017 0 0.025-0 0.006-0 0.014-0 0.022 0 0.998 0.334 1.918 0.897 2.654l-19.812-0.011z"
        ></path>
        <path
          d="M21.653 1.778c-0.202 0.528-0.32 1.139-0.32 1.778s0.117 1.249 0.331 1.813l-18.358-0.035c-0.861-0.074-1.533-0.791-1.533-1.665 0-0.040 0.001-0.079 0.004-0.118-0.003-0.028-0.004-0.068-0.004-0.107 0-0.874 0.671-1.592 1.526-1.665l18.353-0zM24.462 0h-21.156c-1.842 0.068-3.309 1.577-3.309 3.429 0 0.045 0.001 0.089 0.003 0.133-0.002 0.031-0.003 0.076-0.003 0.12 0 1.852 1.467 3.361 3.303 3.429l21.162 0c0.014 0.002 0.031 0.003 0.047 0.003 0.196 0 0.356-0.159 0.356-0.356 0-0.143-0.084-0.266-0.205-0.322-0.927-0.64-1.53-1.688-1.549-2.878 0.019-1.196 0.622-2.244 1.535-2.875 0.135-0.065 0.219-0.188 0.219-0.331 0-0.196-0.159-0.356-0.356-0.356-0.017 0-0.033 0.001-0.049 0.003l0.002-0z"
        ></path>
        <path fill="currentColor" d="M12.444 16l-3.556-3.556-3.556 3.556v-10.667h7.111v10.667z"></path>
      </symbol>
      <symbol id="icon-video" viewBox="0 0 41 32">
        <path
          d="M27.429 4.571v13.714h-22.857v-13.714h22.857zM27.429 0h-22.857c-2.525 0-4.571 2.047-4.571 4.571v13.714c0 2.525 2.047 4.571 4.571 4.571h2.286l-1.577 6.309c-0.043 0.165-0.067 0.354-0.067 0.55 0 1.262 1.023 2.286 2.286 2.286 0.024 0 0.047-0 0.070-0.001l4.362 0c0.020 0.001 0.043 0.001 0.067 0.001 1.068 0 1.965-0.732 2.216-1.722l1.786-7.422h11.429c2.525 0 4.571-2.047 4.571-4.571v-2.286l9.143 2.286v-13.714l-9.143 2.286v-2.286c0-2.525-2.047-4.571-4.571-4.571v0z"
        ></path>
        <path fill="currentColor" d="M4.571 4.571h22.857v6.857h-22.857v-6.857z"></path>
        <path
          fill="#686868"
          d="M9.806 26.446l-0.343 1.349c-0.008 0.034-0.013 0.074-0.013 0.114 0 0.274 0.22 0.497 0.493 0.503h0.96c0.012 0.001 0.027 0.002 0.041 0.002 0.229 0 0.423-0.154 0.483-0.364l0.389-1.604h-2.011z"
        ></path>
      </symbol>
      <symbol id="icon-chat" viewBox="0 0 32 32">
        <path
          d="M0 4v16c0 2.209 1.791 4 4 4h2v8l8-8h14c2.209 0 4-1.791 4-4v-16c0-2.209-1.791-4-4-4h-24c-2.209 0-4 1.791-4 4z"
        ></path>
      </symbol>
      <symbol id="icon-search-delete" viewBox="0 0 32 32">
        <path
          fill="#177af0"
          class="path1 fill-color3"
          d="M32 16.187c0 8.8-7.134 15.933-15.933 15.933s-15.933-7.134-15.933-15.933c0-8.8 7.134-15.933 15.933-15.933s15.933 7.134 15.933 15.933z"
        ></path>
        <path
          fill="#fff"
          class="path2 fill-color11"
          d="M16.947 16l4.867-4.867c0.121-0.121 0.196-0.289 0.196-0.473 0-0.37-0.3-0.669-0.669-0.669-0.185 0-0.352 0.075-0.473 0.196l-4.867 4.867-4.867-4.853c-0.121-0.121-0.288-0.196-0.473-0.196-0.37 0-0.669 0.3-0.669 0.669 0 0.185 0.075 0.352 0.196 0.473l4.867 4.853-4.853 4.867c-0.121 0.121-0.196 0.288-0.196 0.473 0 0.37 0.3 0.669 0.669 0.669 0.185 0 0.352-0.075 0.473-0.196l4.853-4.867 4.867 4.867c0.121 0.121 0.288 0.196 0.473 0.196 0.37 0 0.669-0.3 0.669-0.669 0-0.185-0.075-0.352-0.196-0.473z"
        ></path>
      </symbol>
      <symbol id="icon-avatar" viewBox="0 0 32 32">
        <path
          fill="#fff"
          class="path1 fill-color9"
          d="M16.437 31.153c-8.361 0-15.139-6.778-15.139-15.139s6.778-15.139 15.139-15.139c8.361 0 15.139 6.778 15.139 15.139 0 0.004 0 0.009 0 0.014 0 8.354-6.772 15.126-15.126 15.126-0.005 0-0.009 0-0.014 0z"
        ></path>
        <path
          fill="#3f3f3f"
          class="path2 fill-color1"
          d="M16.437 1.803c0.003 0 0.006 0 0.009 0 7.838 0 14.193 6.354 14.193 14.193s-6.354 14.193-14.193 14.193c-7.832 0-14.182-6.344-14.193-14.174 0-0.001 0-0.001 0-0.001 0-7.839 6.347-14.195 14.182-14.211zM16.437 0c-8.844 0-16.014 7.17-16.014 16.014s7.17 16.014 16.014 16.014c8.844 0 16.014-7.169 16.014-16.014 0-0.015 0-0.032 0-0.050 0-8.817-7.147-15.964-15.964-15.964-0.017 0-0.035 0-0.052 0h0.003z"
        ></path>
        <path fill="#177af0" class="path3 fill-color2" d="M12.62 27.831l0.451 0.135v-2.727h-0.451v2.592z"></path>
        <path fill="#177af0" class="path4 fill-color2" d="M19.831 27.989l0.451-0.131v-2.619h-0.451v2.749z"></path>
        <path
          fill="#177af0"
          class="path5 fill-color2"
          d="M16.491 3.579c-0.001 0-0.003 0-0.005 0-6.868 0-12.435 5.567-12.435 12.435 0 4.244 2.126 7.992 5.372 10.235l0.041-2.087c0-1.645 1.334-2.979 2.979-2.979h8.014c1.645 0 2.979 1.334 2.979 2.979v2.172c3.33-2.266 5.489-6.039 5.489-10.317 0-6.868-5.566-12.437-12.434-12.439zM16.491 20.214c-0.025 0-0.056 0.001-0.086 0.001-2.596 0-4.701-2.105-4.701-4.701s2.105-4.701 4.701-4.701c2.596 0 4.7 2.104 4.701 4.7 0 0.012 0 0.026 0 0.041 0 2.558-2.061 4.635-4.613 4.66z"
        ></path>
      </symbol>
      <symbol id="icon-play" viewBox="0 0 29 32">
        <path
          class="path1"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M27.316 18.007l-23.069 11.84c-0.389 0.206-0.849 0.326-1.338 0.326-1.607 0-2.909-1.302-2.909-2.909 0-0.012 0-0.025 0-0.037l-0-22.631c-0-0.006-0-0.014-0-0.021 0-1.607 1.302-2.909 2.909-2.909 0.455 0 0.885 0.104 1.268 0.29l23.255 10.931c0.885 0.51 1.471 1.451 1.471 2.529 0 1.124-0.638 2.099-1.571 2.584z"
        ></path>
      </symbol>
      <symbol id="icon-search" viewBox="0 0 18 18">
        <path
          fill="transparent"
          d="M16.5 16.5L12.875 12.875M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z"
          stroke="#667085"
          stroke-width="1.66667"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol style="fill: currentColor;" id="icon-delete" viewBox="0 0 32 32">
        <path d="M-0.172 5.497l5.657-5.657 26.663 26.663-5.657 5.657-26.663-26.663z"></path>
        <path d="M-0.172 26.503l26.663-26.663 5.657 5.657-26.663 26.663-5.657-5.657z"></path>
      </symbol>
      <symbol id="icon-cluster" viewBox="0 0 18 18">
        <path
          d="M1 13L9 17L17 13M1 9L9 13L17 9M9 1L1 5L9 9L17 5L9 1Z"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-connection" viewBox="0 0 18 15">
        <path
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linejoin="round"
          d="M 3.1711593,9.3960414 10.425432,-0.47286084 V 5.8073493 h 4.352562 L 7.5237223,15.676251 V 9.3960414 Z"
          id="path2"
        />
      </symbol>
      <symbol id="icon-workspace" viewBox="0 0 18 15">
        <path
          d="M1 3C1 1.89543 1.89543 1 3 1H5.6707C6.25998 1 6.81927 1.25988 7.19928 1.71026L8.40072 3.13419C8.78073 3.58457 9.34002 3.84444 9.9293 3.84444H15C16.1046 3.84444 17 4.73988 17 5.84444V12.3333C17 13.4379 16.1046 14.3333 15 14.3333H3C1.89543 14.3333 1 13.4379 1 12.3333V3Z"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linejoin="round"
        />
        <line
          x1="8.94375"
          y1="11.066"
          x2="14.1063"
          y2="11.066"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
        />
      </symbol>
      <symbol id="icon-job" viewBox="0 0 16 20">
        <path
          d="M11.5 2.75H13.25C13.7141 2.75 14.1592 2.93437 14.4874 3.26256C14.8156 3.59075 15 4.03587 15 4.5V16.75C15 17.2141 14.8156 17.6592 14.4874 17.9874C14.1592 18.3156 13.7141 18.5 13.25 18.5H2.75C2.28587 18.5 1.84075 18.3156 1.51256 17.9874C1.18437 17.6592 1 17.2141 1 16.75V4.5C1 4.03587 1.18437 3.59075 1.51256 3.26256C1.84075 2.93437 2.28587 2.75 2.75 2.75H4.5M5.375 1H10.625C11.1082 1 11.5 1.39175 11.5 1.875V3.625C11.5 4.10825 11.1082 4.5 10.625 4.5H5.375C4.89175 4.5 4.5 4.10825 4.5 3.625V1.875C4.5 1.39175 4.89175 1 5.375 1Z"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <line x1="3.625" y1="9.15" x2="12.375" y2="9.15" stroke="#ffffff" stroke-width="1.2" />
        <line x1="3.625" y1="12.65" x2="12.375" y2="12.65" stroke="#ffffff" stroke-width="1.2" />
      </symbol>
      <symbol id="icon-package" viewBox="0 0 17 18">
        <path
          d="M15.2045 5.16702L8.30514 8.99998M8.30514 8.99998L1.40582 5.16702M8.30514 8.99998L8.30516 16.711M15.6103 12.2943V5.70573C15.6103 5.42761 15.6103 5.28856 15.5694 5.16453C15.5331 5.05481 15.4738 4.9541 15.3955 4.86912C15.307 4.77307 15.1855 4.70553 14.9423 4.57047L8.93587 1.23354C8.70567 1.10565 8.59057 1.04171 8.46868 1.01664C8.3608 0.994453 8.24953 0.994453 8.14165 1.01664C8.01976 1.04171 7.90466 1.10565 7.67446 1.23354L1.66799 4.57047C1.42487 4.70554 1.30331 4.77307 1.2148 4.86912C1.13649 4.9541 1.07723 5.05481 1.04098 5.16453C1 5.28856 1 5.42762 1 5.70573V12.2943C1 12.5724 1 12.7114 1.04098 12.8355C1.07723 12.9452 1.13649 13.0459 1.2148 13.1309C1.30331 13.2269 1.42487 13.2945 1.66799 13.4295L7.67446 16.7665C7.90466 16.8943 8.01976 16.9583 8.14165 16.9834C8.24953 17.0055 8.3608 17.0055 8.46868 16.9834C8.59057 16.9583 8.70567 16.8943 8.93587 16.7665L14.9423 13.4295C15.1855 13.2945 15.307 13.2269 15.3955 13.1309C15.4738 13.0459 15.5331 12.9452 15.5694 12.8355C15.6103 12.7114 15.6103 12.5724 15.6103 12.2943Z"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9578 6.97078L4.65259 2.91235"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-workflow" viewBox="-3 0 27 32">
        <path
          fill="#transparent"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="path1"
          d="M0 9.33v6.67c0 0.001 0 0.001 0 0.002 0 0.356 0.186 0.668 0.466 0.846l9.004 5.572c0.143 0.084 0.316 0.134 0.5 0.134s0.357-0.050 0.505-0.137l8.995-5.567c0.309-0.166 0.517-0.482 0.53-0.848l0-6.672-10 6z"
        ></path>
        <path
          fill="#transparent"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="path2"
          d="M0.45 7.47l9.55 5.83 9.54-5.83c0.3-0.176 0.498-0.498 0.498-0.865s-0.198-0.689-0.494-0.862l-8.545-4.743c-0.287-0.168-0.632-0.268-1-0.268s-0.713 0.1-1.009 0.273l-8.511 4.745c-0.304 0.175-0.505 0.499-0.505 0.869 0 0.358 0.188 0.672 0.471 0.849z"
        ></path>
        <path
          fill="#transparent"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="path3"
          d="M0 18.33v6.67c0 0.001 0 0.001 0 0.002 0 0.356 0.186 0.668 0.466 0.846l9.004 5.572c0.143 0.084 0.316 0.134 0.5 0.134s0.357-0.050 0.505-0.137l8.995-5.567c0.309-0.166 0.517-0.482 0.53-0.848l0-6.672-10 6z"
        ></path>
      </symbol>
      <symbol id="icon-schedules" viewBox="0 0 18 17">
        <path
          d="M9.89062 5.08984V8.55651L12.2017 9.71207"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 1.79259V6.59293M1 6.59293H5.80034M1 6.59293L4.71226 3.10469C5.81707 2.00174 7.2504 1.28773 8.79629 1.07024C10.3422 0.852737 11.9169 1.14353 13.2831 1.89881C14.6494 2.65409 15.7332 3.83293 16.3712 5.25772C17.0092 6.6825 17.1669 8.27605 16.8205 9.79825C16.4741 11.3204 15.6424 12.6888 14.4507 13.6972C13.2589 14.7056 11.7718 15.2994 10.2132 15.3891C8.65469 15.4788 7.10921 15.0596 5.80967 14.1946C4.51012 13.3296 3.52689 12.0656 3.00814 10.5932"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
      <symbol id="icon-settings" viewBox="0 0 20 20">
        <path
          d="M10 12.4545C11.3556 12.4545 12.4545 11.3556 12.4545 10C12.4545 8.64439 11.3556 7.54545 10 7.54545C8.64439 7.54545 7.54545 8.64439 7.54545 10C7.54545 11.3556 8.64439 12.4545 10 12.4545Z"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.0545 12.4545C15.9456 12.7013 15.9131 12.9751 15.9613 13.2405C16.0094 13.5059 16.1359 13.7508 16.3245 13.9436L16.3736 13.9927C16.5258 14.1447 16.6465 14.3252 16.7288 14.5238C16.8112 14.7225 16.8536 14.9354 16.8536 15.1505C16.8536 15.3655 16.8112 15.5784 16.7288 15.7771C16.6465 15.9757 16.5258 16.1562 16.3736 16.3082C16.2217 16.4603 16.0412 16.581 15.8425 16.6634C15.6439 16.7457 15.431 16.7881 15.2159 16.7881C15.0009 16.7881 14.7879 16.7457 14.5893 16.6634C14.3906 16.581 14.2102 16.4603 14.0582 16.3082L14.0091 16.2591C13.8163 16.0705 13.5714 15.9439 13.3059 15.8958C13.0405 15.8477 12.7668 15.8802 12.52 15.9891C12.278 16.0928 12.0716 16.265 11.9263 16.4845C11.7809 16.704 11.7029 16.9613 11.7018 17.2245V17.3636C11.7018 17.7976 11.5294 18.2138 11.2225 18.5207C10.9157 18.8276 10.4994 19 10.0655 19C9.63146 19 9.21525 18.8276 8.90837 18.5207C8.60149 18.2138 8.42909 17.7976 8.42909 17.3636V17.29C8.42276 17.0192 8.3351 16.7565 8.17751 16.5362C8.01992 16.3159 7.79969 16.1481 7.54545 16.0545C7.29868 15.9456 7.02493 15.9131 6.75952 15.9613C6.4941 16.0094 6.24919 16.1359 6.05636 16.3245L6.00727 16.3736C5.8553 16.5258 5.67483 16.6465 5.47617 16.7288C5.27752 16.8112 5.06459 16.8536 4.84955 16.8536C4.6345 16.8536 4.42157 16.8112 4.22292 16.7288C4.02426 16.6465 3.84379 16.5258 3.69182 16.3736C3.53967 16.2217 3.41898 16.0412 3.33663 15.8425C3.25428 15.6439 3.21189 15.431 3.21189 15.2159C3.21189 15.0009 3.25428 14.7879 3.33663 14.5893C3.41898 14.3906 3.53967 14.2102 3.69182 14.0582L3.74091 14.0091C3.92953 13.8163 4.05606 13.5714 4.10419 13.3059C4.15231 13.0405 4.11982 12.7668 4.01091 12.52C3.90719 12.278 3.73498 12.0716 3.51547 11.9263C3.29596 11.7809 3.03873 11.7029 2.77545 11.7018H2.63636C2.20237 11.7018 1.78616 11.5294 1.47928 11.2225C1.1724 10.9157 1 10.4994 1 10.0655C1 9.63146 1.1724 9.21525 1.47928 8.90837C1.78616 8.60149 2.20237 8.42909 2.63636 8.42909H2.71C2.98081 8.42276 3.24346 8.3351 3.46379 8.17751C3.68412 8.01992 3.85195 7.79969 3.94545 7.54545C4.05437 7.29868 4.08686 7.02493 4.03873 6.75952C3.99061 6.4941 3.86408 6.24919 3.67545 6.05636L3.62636 6.00727C3.47422 5.8553 3.35352 5.67483 3.27118 5.47617C3.18883 5.27752 3.14644 5.06459 3.14644 4.84955C3.14644 4.6345 3.18883 4.42157 3.27118 4.22292C3.35352 4.02426 3.47422 3.84379 3.62636 3.69182C3.77834 3.53967 3.95881 3.41898 4.15746 3.33663C4.35611 3.25428 4.56905 3.21189 4.78409 3.21189C4.99913 3.21189 5.21207 3.25428 5.41072 3.33663C5.60937 3.41898 5.78984 3.53967 5.94182 3.69182L5.99091 3.74091C6.18374 3.92953 6.42865 4.05606 6.69406 4.10419C6.95948 4.15231 7.23322 4.11982 7.48 4.01091H7.54545C7.78745 3.90719 7.99383 3.73498 8.1392 3.51547C8.28457 3.29596 8.36259 3.03873 8.36364 2.77545V2.63636C8.36364 2.20237 8.53604 1.78616 8.84292 1.47928C9.14979 1.1724 9.56601 1 10 1C10.434 1 10.8502 1.1724 11.1571 1.47928C11.464 1.78616 11.6364 2.20237 11.6364 2.63636V2.71C11.6374 2.97328 11.7154 3.23051 11.8608 3.45002C12.0062 3.66953 12.2126 3.84174 12.4545 3.94545C12.7013 4.05437 12.9751 4.08686 13.2405 4.03873C13.5059 3.99061 13.7508 3.86408 13.9436 3.67545L13.9927 3.62636C14.1447 3.47422 14.3252 3.35352 14.5238 3.27118C14.7225 3.18883 14.9354 3.14644 15.1505 3.14644C15.3655 3.14644 15.5784 3.18883 15.7771 3.27118C15.9757 3.35352 16.1562 3.47422 16.3082 3.62636C16.4603 3.77834 16.581 3.95881 16.6634 4.15746C16.7457 4.35611 16.7881 4.56905 16.7881 4.78409C16.7881 4.99913 16.7457 5.21207 16.6634 5.41072C16.581 5.60937 16.4603 5.78984 16.3082 5.94182L16.2591 5.99091C16.0705 6.18374 15.9439 6.42865 15.8958 6.69406C15.8477 6.95948 15.8802 7.23322 15.9891 7.48V7.54545C16.0928 7.78745 16.265 7.99383 16.4845 8.1392C16.704 8.28457 16.9613 8.36259 17.2245 8.36364H17.3636C17.7976 8.36364 18.2138 8.53604 18.5207 8.84292C18.8276 9.14979 19 9.56601 19 10C19 10.434 18.8276 10.8502 18.5207 11.1571C18.2138 11.464 17.7976 11.6364 17.3636 11.6364H17.29C17.0267 11.6374 16.7695 11.7154 16.55 11.8608C16.3305 12.0062 16.1583 12.2126 16.0545 12.4545Z"
          stroke="#ffffff"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="icon-apps" viewBox="0 0 18 18">
        <path
          d="M11.6667 1H12.7333C14.2268 1 14.9735 1 15.544 1.29065C16.0457 1.54631 16.4537 1.95426 16.7094 2.45603C17 3.02646 17 3.7732 17 5.26667V12.7333C17 14.2268 17 14.9735 16.7094 15.544C16.4537 16.0457 16.0457 16.4537 15.544 16.7094C14.9735 17 14.2268 17 12.7333 17H11.6667M7.22222 4.55556L11.6667 9M11.6667 9L7.22222 13.4444M11.6667 9L1 9"
          stroke="white"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="icon-import-export" viewBox="0 0 21 16">
        <path
          d="M1.6546 5.22414L5.58219 1.27504M5.58219 1.27504L9.50979 5.22414M5.58219 1.27504V10.4896"
          stroke="#BDC5CF"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.3454 10.7759L15.4178 14.725M15.4178 14.725L11.4902 10.7759M15.4178 14.725V5.51045"
          stroke="#BDC5CF"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>
    </svg>
  `,
  selector: 'icons-sprite',
})
export class IconsSpriteComponent {}
